import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, EventEmitter, Output, ViewEncapsulation, } from '@angular/core';

import { MysqlService } from './../../../../services/mysql.service';
import { SubjectService } from './../../../../api/subjectService';
import {DemoService} from '../../../../demo.service';

import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, delay, pipe, retry } from 'rxjs';
import { BsModalService, BsModalRef, ModalBackdropOptions, ModalOptions } from 'ngx-bootstrap/modal';
// import { HotToastService } from '@ngneat/hot-toast';

import { SubjectServiceListComponent } from './subject-service-list/subject-service-list.component';
import { NgForm } from '@angular/forms';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../../services/legal-datetime.service';
import { SubjectNotes } from './../../../../shared/models/subjectNotes.model';
import { CountService, HtmlEditorService, ImageService, InsertHtml, LinkService, PasteCleanupService, ToolbarService, modelChanged } from '@syncfusion/ej2-angular-richtexteditor';
import { Job } from './../../../../shared/models/job.model';
import { DataUtil } from '@syncfusion/ej2-data';
import { SendEmailWidgetComponent } from './../../../../components/communication/send-email-widget/send-email-widget.component';
import { HotToastService } from '@ngneat/hot-toast';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard

// import the subjectEdit component so I can refresh it on update.
// import { SubjectEditComponent } from '../subject-edit/subject-edit.component';

import * as moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Component({
  selector: 'app-subject-service',
  templateUrl: './subject-service.component.html',
  styleUrls: ['./subject-service.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, CountService, PasteCleanupService ]
})
export class SubjectServiceComponent implements OnInit {

  @Input() subject_id: number;
  @Input() job_id: number;
  @Input() base_attempt_model: any;
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

/*
job_id: any;
subject_id: any;
*/

@ViewChild('defaultRTE_spoken', {static: false}) defaultRTE_spoken;


sections: { [key: string]: boolean } = {};

// NEW system (safe, separate from legacy)
sectionGroups: { [key: string]: boolean } = {};
skipValidationGroups: { [key: string]: boolean } = {};

// group names
GROUPS = {
  OCCUPANCY_11_12: 'group_occupancy_11_12',
  DRIVEBY_12: 'group_driveby_12',
  SECTION29: 'group_section29'
};




search_results: any[];

public passed_job_id: string;
allAutomations = [];
allSubjects = [];

allAttempts = [];

local_date_time: any;

@ViewChild('attemptForm') form: any;

  model: SubjectService;
  model2: SubjectNotes;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: any;
 // bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  public mytime: Date = new Date();
  staffList: any;
  serviceMethods: any;
  subjectRelationships: any;
  exactServiceMethods: any;
  get_latest_subject_service_id: any;
  subject_services: any;
  serviceOutcomes: any;
  assignedList: any;
  assignedBrandList: any;
  subjectServiceOutcome: any;
  current_subject: any;
  subjectLocationStatuss: any;
  subjectLocationStatussFound: any;
  brand: any;
  idx: any;
  title: any;
  current_service_number: any;
  converted_service_number: number;
  subjectAttemptTypesList: any;
  subject_attempt_type_label: string;

  new_note_model: any = [];

       // access the template form
       @ViewChild('attemptForm') attemptForm: NgForm;
  all_router_details: string;
  get_latest_subject_note_id: any = [];
  current_job: any = [];
  sessionUserLevel: any;
  assignedAgentsList: any;
  allRecipients: any;
  assignedBrandList_data: any;
  serviceMethod: any;
  subject_service_method_name: any;
  subjectAttemptType: any;
  subject_attempt_type_name: any;
  subject_contact_emails: any;
  email_address_served: string;


  allAttachedFiles: any = [];
  allEmailRecipients: any = [];
  allClientEmailRecipients: any = [];
  allLoginEmailRecipients: any = [];
  allClientInvoiceEmailRecipients: any = [];

  allAttachments = [];
  property_images = [];
  property_sign_images = [];
  property_mail_images = [];
  property_vehicles_images = [];
  property_pets_images = [];
  property_occupancy_images = [];
  property_condition_images = [];
  property_type_images = [];

  set_job_file: number; 
  set_subject_file: number;
  serviceOutcomes_filtered: any;
  subject_outcome_type_label: string;
  subject_contact_numbers: any;
  phone_number: string;
  is_count_subject_service_outcome_lookup: any;
  is_count: any;
  showNewAddress: boolean;
  propertyTypesList: any;
  showAllAttachments: boolean;
  job_subjects: any;
  local_date_time_offset: number;
  local_date_time_zone: string;
  service_local_timezone: string;
  service_local_offset: number;
  service_local: string;
  
 // defined the array of data
 public data_timezones: { [key: string]: Object }[] = [ 
// { Id: 'game1', Game: 'Badminton' },
// { Id: 'game2', Game: 'Football' },
// { Id: 'game3', Game: 'Tennis' }

{ Id: 'Pacific/Norfolk', Timezone: 'Pacific/Norfolk', Offset: '+11:00', DST: '+12:00'  },
{ Id: 'Antarctica/Casey', Timezone: 'Antarctica/Casey', Offset: 'UTC+08:00', DST: '+11:00'  },
{ Id: 'Australia/Lord_Howe', Timezone: 'Australia/Lord_Howe', Offset: '+10:30', DST: '+11:00'  },
{ Id: 'Antarctica/Macquarie', Timezone: 'Antarctica/Macquarie', Offset: '+10:00', DST: '+11:00'  },
{ Id: 'Australia/Sydney', Timezone: 'Australia/Sydney', Offset: '+10:00', DST: '+11:00'  },
{ Id: 'Australia/Hobart', Timezone: 'Australia/Hobart', Offset: '+10:00', DST: '+11:00'  },
{ Id: 'Australia/Melbourne', Timezone: 'Australia/Melbourne', Offset: '+10:00', DST: '+11:00'  },
{ Id: 'Australia/Brisbane', Timezone: 'Australia/Brisbane', Offset: '+10:00', DST: '+11:00'  },
{ Id: 'Australia/Lindeman', Timezone: 'Australia/Lindeman', Offset: '+10:00', DST: '+11:00'  },
{ Id: 'Australia/Broken_Hill', Timezone: 'Australia/Broken_Hill', Offset: '+9:30', DST: '+10:30'  },
{ Id: 'Australia/Adelaide', Timezone: 'Australia/Adelaide', Offset: '+9:30', DST: '+10:30'  },
{ Id: 'Australia/Darwin', Timezone: 'Australia/Darwin', Offset: '+9:30', DST: '+09:30'  },
{ Id: 'Australia/Eucla', Timezone: 'Australia/Eucla', Offset: '+8:45', DST: '+08:45'  },
{ Id: 'Australia/Perth', Timezone: 'Australia/Perth', Offset: '+8:00', DST: '+08:00'  },


];
// maps the appropriate column to fields property
public fields_timezones: Object = { text: 'Timezone', value: 'Id' };
//set the placeholder to DropDownList input
public text_timezones: string = "Select a Agent Local Timezone";
  load_ssot_id: number;
  subject_service_outome_template: Object;
  show_paragraph: number;
  changes_made: any;
  current_job_fields: any;
  job_model: any;
  subject_model: any;
  subject_service_types: Object;
  subject_service_type: any;
  subject_attempt_type: any;
  subject_service_method: any;
  subject_service_agent: any;
  var_subject_attempt_type_name_Upper: any;
  var_service_method_name: any;
  serviceFellowRelationship: Object;
  subject_service_fellow_relationship: any;
  subjectExactServiceMethod: any;
  subjectLocationStatus: any;
  subjectLocationStatusFound: any;
  job_report_client: any;
  job_subject_type: any;
  subject_job_subject_type: any;
  var_service_outcome_name: any;
  var_location_status_name: any;
  var_location_status_found_name: any;
  var_exact_service_method_name: any;
  subjectAttemptPropertyType: any;
  var_property_type_name: any;
  var_time_service: any;


  // Text editor Settings
  public simpleToolBarService: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo',
    // {
    //   tooltipText: 'Insert Promotion',
    //   undo: true,
    //   click: this.onClickPromotionButton.bind(this),
    //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    // }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  };  
  set_general_notes: any;
  set_property_type_details_HTML: any;
  property_occupied_details_HTML: any;
  property_forsale_or_lease_sign_details_HTML: any;
  property_mail_details_HTML: any;
  property_vehicles_sighted_details_HTML: any;
  property_pets_details_HTML: any;
  property_occupancy_details_HTML: any;
  property_condition_HTML: any;
  attempts_notes_HTML: any;
  person_spoken_with_advised_HTML: any;
  vehicles_notes_HTML: any;
  neighbours_notes_HTML: any;
  calling_card_notes_HTML: any;
  postal_mail_notes_HTML: any;
  phone_call_notes_HTML: any;
  email_contents_HTML: any;
  subject_name: string;
  service_under_order_HTML: any;
  converted_service_number_muliple: number;
  current_service_number_multiple: Object;
  base_subject_id: number;
  var_subject_attempt_type_name: any;

  confirm_details: number;
  subject_service_outome_template_resolution_outcomes: any;
  subject_service_resolution_outcome_required: any;
  subject_service_resolution_outcomes: any;
  subject_service_resolution_outcomes_by_type: any[] = [];
  resolutionOutcomeAnswersByType: any = {};

  allResolutions = [];
  form_validator_switch_value = true;

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    vcr: ViewContainerRef,
     public bsModalRef: BsModalRef,
     public gfunc: GlobalFunctionsService,
     public _mysqlService: MysqlService,
     public toastr: HotToastService,
     public legalDate: LegalDateTimeService,
     private sanitizer: DomSanitizer,
     private clipboard: Clipboard, // ciipboard
     private http: HttpClient,
  ) {

    // login vars
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

       

//@// https://stackoverflow.com/questions/9772955/how-can-i-get-the-timezone-name-in-javascript
//  https://www.w3schools.com/jsref/jsref_gettimezoneoffset.asp
// https://www.agiratech.com/angular-date-pipe-timezone-examples
// 

           // :: show hide update and ceate components
    this.showNewAddress = false;	

    // DataUtil.serverTimezoneOffset = new Date().getTimezoneOffset()/60; 
    this.local_date_time = new Date(new Date().getTime());
    var offset = new Date().getTimezoneOffset();
    this.local_date_time_offset = offset;
    this.local_date_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone

    this.service_local_timezone = this.gfunc.getTimezoneName(); // this sets the current clients user timezone for the database.
    this.service_local_offset = new Date().getTimezoneOffset(); // this sets the current clients user timezone for the database.
    this.service_local = Intl.DateTimeFormat().resolvedOptions().timeZone

    this.confirm_details = 0;

   }

  ngOnInit() {

    this.passed_job_id = 'Initial State';

    this.base_subject_id = this.subject_id;

    
    this.getBrandUsers('94'); // for the drop down
    this.getServiceMethods();
    // this.getServiceOutcomes();
this.getServiceOutcomesAccessLevel(this.gfunc.sessionUserLevel)
    this.getSubjectRelationships();
    this.getExactServiceMethods();

    this.getSubjectAttemptTypes();
    this.getPropertyTypes();

    // this.setAttemptTypeLabel();   // set this on change of dropdown
    
    // this.getSubjectServices(this.subject_id);
    // this.getSubjectAgentAssigned(this.subject_id);
    
 

      // Noved this to a widget component for muiltipe
if(this.base_attempt_model){

//   this.getSubjectAgentBrandsAssigned(this.subject_id);
//   this.getSubjectAgentBrandsAssigned2(this.subject_id); // get assigned_to_agents array
//   this.getJobSubject(this.subject_id);
//   this.getSubjectLocationStatuss();
//   this.getSubjectLocationStatussFound();
//  //  this.model.subject_location_status_found_id = '1'; // set the default check list so it does not stay as nill

//  this.getSubjectContactEmails(this.subject_id);
//  this.getSubjectContactNumbers(this.subject_id);


//  this.model = new SubjectService();// Mught have to put in an on changes so that it only loads on changes... etc... // This is

//   this.model.subject_id = this.subject_id;
//   this.model = this.base_attempt_model
//   // run the paragraph loader.
//   this.LoadSubjectserviceOutcomeTemplateParagraph(this.model)
}

if(!this.base_attempt_model){
    this.model = new SubjectService();// Mught have to put in an on changes so that it only loads on changes... etc... // This is
    this.model.date_service = this.mytime;
    this.model.time_service = this.mytime;

    this.model.general_notes = ''; // remove undefined from editor.

    // need to set the txt....??
    const dateTime = new Date(this.mytime).toLocaleTimeString('en-AU', {
      hour: 'numeric', minute: 'numeric', hour12: true
      });


    // this.model.time_service_text = this.mytime;

            // this.model.time_service_text = dateTime;


    this.model.time_service_local = this.local_date_time
    this.model.date_service_local = this.local_date_time

    this.model.service_local_timezone = this.service_local_timezone;
    this.model.service_local_offset = this.service_local_offset;
    this.model.service_local = this.service_local;


    // October 2023
    this.model.subject_id = this.subject_id;




    // set image arrays to empty
        this.model.property_images = [];
        this.model.property_sign_images = [];
        this.model.property_mail_images = [];
        this.model.property_vehicles_images = [];
        this.model.property_pets_images = [];
        this.model.property_occupancy_images = [];
        this.model.property_condition_images = [];

   // this.model.who_service = this.sessionUserId;
   this.getSubjectAgentBrandsAssigned(this.subject_id);
   this.getSubjectAgentBrandsAssigned2(this.subject_id); // get assigned_to_agents array
   this.getJobSubject(this.subject_id);
   this.getSubjectLocationStatuss();
   this.getSubjectLocationStatussFound();
  //  this.model.subject_location_status_found_id = '1'; // set the default check list so it does not stay as nill

  this.getSubjectContactEmails(this.subject_id);
  this.getSubjectContactNumbers(this.subject_id);

  


  
// establish the field_meta model
//push this to the model on the start....
// this.model.property_sign_field_meta = [{
//   field: [{
//     value: "",
//     name: "agency_name",
//     model_name: "model.property_sign_field_meta",
//     master_field: "",
//     disabled: "no",
//     required: "no",
//     alt: "",
//     title: "",
//     field_type: "text",
//     class: "typeahead_3 form-control",
//     placeholder: "Agency Name",
//     label: "Agency Name",
//   }],
  
//   agency_name: "",
//   agency_contact: ""
// }];

// this.model.property_sign_field_meta = [];
// this.model.property_sign_field_meta.push({
//   value: "Mr Smart Signs Agent",
//   name: "agent_name",
//   model_name: "model.property_sign_field_meta[0].agency_name",
//   master_field: "",
//   disabled: "disabled",
//   required: "required",
//   alt: "",
//   title: "",
//   type: "text",
//   class: "typeahead_3 form-control text-success",
//   placeholder: "Agent Name",
//   label: "Agent Name",
// });
// this.model.property_sign_field_meta.push({
//   value: "",
//   name: "agency_name",
//   model_name: "model.property_sign_field_meta[i].agency_name",
//   master_field: "",
//   disabled: "disabled",
//   required: "required",
//   alt: "",
//   title: "",
//   type: "text",
//   class: "typeahead_3 form-control text-bold",
//   placeholder: "Agency Name",
//   label: "Agency Name",
// });
// this.model.property_sign_field_meta.push({
//   value: "",
//   name: "agency_contacts",
//   model_name: "model.property_sign_field_meta[1].agency_contacts",
//   master_field: "",
//   disabled: "disabled",
//   required: "required",
//   alt: "",
//   title: "",
//   type: "text",
//   class: "typeahead_3 form-control",
//   placeholder: "Agency Contact Phone Numbers",
//   label: "Agency Contacts",
// });


// this.model.property_sign_field_meta.push({
//   value: "Wilsha Wallis",
//   name: "agent_name",
//   model_name: "model.property_sign_field_meta[i].agency_name",
//   master_field: "",
//   disabled: "disabled",
//   required: "required",
//   alt: "",
//   title: "",
//   type: "text",
//   class: "typeahead_3 form-control text-success",
//   placeholder: "Agent Name",
//   label: "Agent Name",
// });




this.model.property_sign_field_meta = this.model.property_sign_field_meta; // ?? this may be causing errors.
    } // end if no base


  }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
 this.modalRef = this.modalService.show(template, config);
}


getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.current_subject = data;
      const res = data[0];
      // set the model.address details.
      this.model.address_1 = res.street_address;
     // this.model.address_2 = res.address_2;
      this.model.state = res.state;
      this.model.postcode = res.postcode;
      this.model.suburb = res.suburb;
      this.model.country = res.country;
      this.model.business_name = res.business_name;
      this.model.title = res.title;
      this.model.first_name = res.first_name;
      this.model.middle_name = res.middle_name;
      this.model.surname = res.surname;
      // set the extra fields for universal notes and logs etc..
      this.model.file_number = res.file_number;
      this.model.reference_number = res.reference_number;
      this.model.subject_number = res.subject_number;


        // set for notice and log
        const cleanSubjectNamePart = value => value === undefined || value === null
          ? ''
          : String(value).trim();
        const subject_business_name = cleanSubjectNamePart(res.business_name);
        const subject_person_name = [res.title, res.first_name, res.middle_name, res.surname]
          .map(cleanSubjectNamePart)
          .filter(value => value !== '')
          .join(' ');
        const subject_name = subject_business_name || subject_person_name;

          this.subject_name = subject_name;
          this.model.subject_name = subject_name;


      this.subject_model = DataUtil.parse.parseJson(res);
      // added the entire current subject to the model
      this.model.subject_model = this.subject_model;
       this.model = this.model;
   
   
      this.getJob(res.job_id);


     

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 // created so ensure paragraph renders before submission
confirmDetailsBeforeSubmit(confirm_details){
  this.confirm_details = confirm_details;
}





  getSubjectServiceOutcomeTemplate_ResolutionOutcomes(ssot_id) {
    this._demoService.getSubjectServiceOutcomeTemplate(ssot_id).subscribe(
       data => { this.subject_service_outome_template_resolution_outcomes = data;
        let res = data[0];
  
        this.subject_service_resolution_outcome_required = res.subject_service_resolution_outcome_required;

        // preload the resolutions
        let new_model = {
                  subject_service_resolution_outcome_array: JSON.parse(res.subject_service_resolution_outcome_array)
                }
      // this.form.controls['subject_service_resolution_outcome_array'].patchValue(JSON.stringify(data.subject_service_resolution_outcome_array)); // works by setting the new frorm value from parent modal.
      this.getSystemResolutionsArray(new_model)
      this.allResolutions = JSON.parse(res.subject_service_resolution_outcome_array);
      if(res.subject_service_resolution_outcome_array == null){this.allResolutions = []} // Sets incase of nulls
      this.syncResolutionOutcomeAnswersFromModel(this.model);
  





  
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


getSystemResolutionsArray(request_array) {
  this._demoService.getSystemResolutionsArray(request_array).subscribe(
     data => { this.subject_service_resolution_outcomes = data;
      this.subject_service_resolution_outcomes_by_type = this.groupResolutionOutcomesByType(data);
      this.syncResolutionOutcomeAnswersFromModel(this.model);
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

groupResolutionOutcomesByType(outcomes: any): any[] {
  const grouped = [];
  Object(outcomes || []).forEach((outcome) => {
    if (outcome.is_active != null && outcome.is_active !== 1 && outcome.is_active !== '1' && outcome.is_active !== true && outcome.is_active !== 'Y') {
      return;
    }
    if (outcome.is_visible != null && outcome.is_visible !== '' && outcome.is_visible !== 1 && outcome.is_visible !== '1' && outcome.is_visible !== true && outcome.is_visible !== 'Y') {
      return;
    }
    const typeActive = outcome.subject_service_resolution_outcome_type_is_active;
    if (typeActive != null && typeActive !== 1 && typeActive !== '1' && typeActive !== true && typeActive !== 'Y') {
      return;
    }
    const typeId = Number(outcome.subject_service_resolution_outcome_type_id || 0);
    const typeName = outcome.subject_service_resolution_outcome_type_name || 'Unassigned';
    let group = grouped.find(item => item.type_id === typeId);
    if (!group) {
      group = { type_id: typeId, type_name: typeName, outcomes: [] };
      grouped.push(group);
    }
    group.outcomes.push(outcome);
  });
  return grouped;
}

syncResolutionOutcomeAnswersFromModel(model) {
  if (!model) {
    return;
  }
  let answers = [];
  if (model.subject_service_resolution_outcome_type_answer_array) {
    try {
      answers = typeof model.subject_service_resolution_outcome_type_answer_array === 'string'
        ? JSON.parse(model.subject_service_resolution_outcome_type_answer_array)
        : model.subject_service_resolution_outcome_type_answer_array;
      if (typeof answers === 'string') {
        answers = JSON.parse(answers);
      }
    } catch (e) {
      answers = [];
    }
  }
  const answerList = Array.isArray(answers)
    ? answers
    : Object.keys(answers || {}).map(key => answers[key]);
  answerList.forEach(answer => {
    if (answer && answer.type_id != null && answer.outcome_id != null) {
      this.resolutionOutcomeAnswersByType[Number(answer.type_id)] = String(answer.outcome_id);
    }
  });
  if (model.subject_service_resolution_outcome_id != null && model.subject_service_resolution_outcome_id !== '' && Number(model.subject_service_resolution_outcome_id) > 0) {
    const legacyOutcomeId = String(model.subject_service_resolution_outcome_id);
    let targetTypeId: any = null;
    Object(this.subject_service_resolution_outcomes_by_type || []).forEach(group => {
      const groupOutcomes = Array.isArray(group.outcomes)
        ? group.outcomes
        : Object.keys(group.outcomes || {}).map(key => group.outcomes[key]);
      const found = groupOutcomes.some((outcome: any) => String(outcome.id) === legacyOutcomeId);
      if (found) {
        targetTypeId = Number(group.type_id);
      }
    });
    if (targetTypeId != null && !this.resolutionOutcomeAnswersByType[targetTypeId]) {
      this.resolutionOutcomeAnswersByType[targetTypeId] = legacyOutcomeId;
    } else if (targetTypeId == null && !this.resolutionOutcomeAnswersByType[1]) {
      this.resolutionOutcomeAnswersByType[1] = legacyOutcomeId;
    }
  }
}

prepareResolutionOutcomeAnswers(model) {
  const answers = [];
  let primaryOutcomeId = null;
  Object(this.subject_service_resolution_outcomes_by_type || []).forEach(group => {
    const outcomeId = this.resolutionOutcomeAnswersByType[group.type_id];
    if (outcomeId != null && outcomeId !== '') {
      answers.push({
        type_id: Number(group.type_id),
        outcome_id: Number(outcomeId)
      });
      if (
        primaryOutcomeId == null
        && (
          Number(group.type_id) === 1
          || String(group.type_name || '').toLowerCase() === 'primary'
        )
      ) {
        primaryOutcomeId = Number(outcomeId);
      }
    }
  });
  model.subject_service_resolution_outcome_type_answer_array = JSON.stringify(answers);
  model.subject_service_resolution_outcome_id = primaryOutcomeId || (answers[0] ? answers[0].outcome_id : model.subject_service_resolution_outcome_id || null);
}



 getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.current_job = data;
      const res = data[0];
      // set the model.address details.
      this.model.brand_report_id = res.brand_report_id;
      this.model.brand_invoice_id = res.brand_report_id;

      this.job_model = DataUtil.parse.parseJson(res);
      // Also set the full job model in the model
      this.model.job_model = this.job_model;

      this.model = this.model;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }


 getSubjectAgentAssigned(subject_id) {
  this._demoService.getSubjectAgentsAssigned(subject_id).subscribe(
     data => { this.assignedList = data;
    },
     err => console.error(err),
     () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
      // this.assignedBrandList = data;
      this.assignedBrandList_data = data;
      // need to add a filter so for agent entry security - can only select themself.
// new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
  let newArr = Object(data).filter((sbi)=>(sbi.brand_id == this.gfunc.sessionBrandId)); // User this if filter is needed.
   // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
  this.assignedBrandList = DataUtil.parse.parseJson(newArr);
  // this.grid.refresh();
  
  } else {
    // this.subject_services_data = data;
    this.assignedBrandList = data;
    // this.grid.refresh();
  }


    },
     err => console.error(err),
     () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned2(subject_id) {
  this.allRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
      console.log('allRecipients LOAD: ', JSON.stringify(this.allRecipients));

    },
     err => console.error(err),
     () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

 getSubjectAttemptTypes() {
  this._demoService.getSubjectAttemptTypes().subscribe(
    data => { this.subjectAttemptTypesList = data; },
    err => console.error(err),
  );
  }

  getPropertyTypes() {
    this._demoService.getPropertyTypes().subscribe(
      data => { this.propertyTypesList = data; },
      err => console.error(err),
    );
    }


    getPropertyType(property_type_id) {
      this._demoService.getPropertyType(property_type_id).subscribe(
        data => { 
          // this.subjectAttemptPropertyType = data;
      let res = data[0]
      this.subjectAttemptPropertyType = DataUtil.parse.parseJson(res);
        
        },
        err => console.error(err),
      );
      }
  

 getServiceOutcomes() {
  this._demoService.getServiceOutcomes().subscribe(
    data => { this.serviceOutcomes = data; 
    
    
    
    
    },
    err => console.error(err),
  );
  }

  getServiceOutcomesAccessLevel(access_level) {
    this._demoService.getServiceOutcomesAccessLevel(access_level).subscribe(
      data => { this.serviceOutcomes = data; 
      
      
      
      
      },
      err => console.error(err),
    );
    }

 getServiceMethods() {
  this._demoService.getServiceMethodsMenu().subscribe(
    data => { this.serviceMethods = data; },
    err => console.error(err),
  );
  }


  getSubjectRelationships() {
    this._demoService.getSubjectRelationships().subscribe(
      data => { this.subjectRelationships = data; },
      err => console.error(err),
    );
    }

    getExactServiceMethods() {
      this._demoService.getExactServiceMethods().subscribe(
        data => { this.exactServiceMethods = data; },
        err => console.error(err),
      );
      }



// New function to accept muliple subjects/same details insert
createSubjectServiceWithArray(model){

  // if subject array ! [] and additional_sibjects >= 1
  // Loop through the 
// model.subject ID == the next in the loop.
  // createSubjectService(model)


///  :: MUST PUSH THE CURRENT SUBJECT ID TO THE ARRAY. // this way I dont have to run the original scrupt as well.
// this.addAutomationFromFunction(model, this.subject_id); // add the current subject first


  // else just run once on the the current subject as norma.
  // Moved to button press to remove more confusion.
                  //   model.subject_id = this.subject_id;
                  // this.createSubjectService(model) // now run the current subject insert

 // have a break then then start the loops/
// setTimeout(() => {                   
//   console.log("Now Ready to load...");
//                 }, 2000);


  const set_subject_array = JSON.parse(model.subject_array);
  const count_subject_array = JSON.parse(model.subject_array).length;
  console.log("count_subject_array: " + count_subject_array)



  
// SEE HOW AUTOMATIONS GO AND WORK WITH MULTiples....
  //now do muiltiples
  for(let z=0; z < count_subject_array; z++) {

  // Now way of doing loop to see if runs one by one.
  // let z=0;
  // for(const item of set_subject_array ) {
  //  // z++
  //     console.log('Now loop of Item:' + item);

    console.log("A : subject_array count:", z ); 
    console.log("A : Subject Id:", set_subject_array[z] ); 


    // Need to lookup the unique service count number for each subject so that each subject gets correct counts. (ie not just countint the current one, but lookup others in array as well)
    
    model.subject_id = set_subject_array[z]; // set new Subject ID.
    // model.subject_id = item; // set new Subject ID.




   

                      // Get correct counts for other subjects in array
                            this.getSubjectServiceOutcomeIsCount(model.subject_service_outcome_id); // determines and sets is_count?

                            // this.onChangeServiceCountSubjectArray(model, model.who_service); /// ? This needs to be unique to each subject. -- giving nulls

                            this.getJobSubjectAttendancesCountNumber(model);
                            model.is_count = this.is_count;
                            // model.service_number = this.model.service_number; // ??????? cant work this one out!!!
               
                            // alert("This is the current i Count: " + this.is_count);


                    // setTimeout(() => {  
                          console.log("A Simple Pause!"); 
                          console.log('model.service_number:  ' + model.service_number)
                          model.subject_id = set_subject_array[z]; // set new Subject ID.
                          // model.subject_id = item; // set new Subject ID.

                 
                            // THIS WORKS BUT STOPS THE COUNTS TO WORK PROPERLY         
                                      // // set correct subect variables
                                      this._demoService.getJobSubject( model.subject_id).subscribe(
                                      // this._demoService.getJobSubject( item).subscribe(
                                        dataB => { this.current_subject = dataB;
                                        const res33 = dataB[0];
                                        // set the model.address details.
                                        // this.model.address_1 = res.street_address;
                                        // // this.model.address_2 = res.address_2;
                                        // this.model.state = res.state;
                                        // this.model.postcode = res.postcode;
                                        // this.model.suburb = res.suburb;
                                        // this.model.country = res.country;
                                        // this.model.business_name = res.business_name;
                                        // set the extra fields for universal notes and logs etc..
                                        model.file_number = res33.file_number;
                                        model.reference_number = res33.reference_number;
                                        model.subject_number = res33.subject_number;
                                  
                                        //  this.getJob(res.job_id);
                                  
                                    return;
                                  
                                      }
                                      // ,
                                      //   err => console.error(err),
                                      //   // () => console.log('done loading Trace Types')
                                      ); 
   
                               // Model.service number not working when not on the first subject?///
                            // Curretnly testing for subject 2
                            // alert("This is the current Count: " + this.model.service_number);
                            model.service_number = this.model.service_number; // ??????? cant work this one out!!!
                            // alert("This is the current Count2 model: " + model.service_number);

                                    this.createSubjectServiceMultiple(model);



                    console.log("Now Ready to load...");
                  // }, 0); //was 1100

  //  z++  // increments z for the old system
  } // end loop // now for




}




// Does this function Render the Paragrahs??? March 24

createSubjectServiceMultiple(model) {

  // // double check if muiltiple to change the subjcet number
  // if(model.additional_subject != 1 ){
  // model.subject_id = this.subject_id;
  //   }


  model.job_id = this.job_id;
  model.created_by = this.sessionUserId;
  model.updated_by = this.sessionUserId; // Fix mysql errors 2025
  model.service_file_array =  JSON.stringify(model.service_file_array);
  model.is_count = this.is_count;  ///??????? do I need to change this to fix counts

  // stringify the image attachment arrays
          model.property_images =  JSON.stringify(model.property_images);
          model.property_sign_images =  JSON.stringify(model.property_sign_images);
          model.property_mail_images =  JSON.stringify(model.property_mail_images);
          model.property_vehicles_images =  JSON.stringify(model.property_vehicles_images);
          model.property_pets_images =  JSON.stringify(model.property_pets_images);
          model.property_occupancy_images =  JSON.stringify(model.property_occupancy_images);
          model.property_condition_images =  JSON.stringify(model.property_condition_images);
          model.property_type_images =  JSON.stringify(model.property_type_images);


// look up names here to add into notes july 2022 updates
  this.getServiceMethod(model.subject_service_method_id);
  this.getSubjectAttemptType(model.subject_attempt_type_id);
  // email set
  model.email_address_served = this.email_address_served; // sets from drop down


  // August 2023 - TimeZone Fixed Text
          // set a fixed time
          const dateTime = new Date(model.time_service).toLocaleTimeString('en-AU', {
            hour: 'numeric', minute: 'numeric', hour12: true
            });


          // this.model.time_service_text = this.mytime;
                    // this.model.time_service_text = dateTime;
                    // model.time_service_text = dateTime;

          // Plain text Paragrap. strip the tags through a function // SEE IF THIS WORDS TO CREATE  NON formatted paragraph automatically
          model.service_paragraph_rendered_plain_text = this.removeTags(model.service_paragraph_rendered);
 
  this.prepareResolutionOutcomeAnswers(model);

  this._demoService.createSubjectService(model).subscribe(
       data => {  this.get_latest_subject_service_id = data; // this is the retuned json upon creation.
        // this.getTraceCandidateNotes(this.trace_candidate_id);

       // CreateJob3Component.getTraceCandidateNotes();

       // CreateJob3Component.returned.next(false);
      ///  this.toastr.info('Service Entered!');
      // this.getSubjectServices(this.subject_id);

                  //   // :: @ INSERT NOTE & LOG this inserts both on create.
                  // alert('SubjectNUmber' + model.subject_number)
                    this.createSubjectNoteMultiple(model, this.get_latest_subject_service_id.last_insert_id); // wend back to this and it seemed to work. // Notes wron on insert 10x's
                    // this.createSubjectNoteMultiple(model); // wend back to this and it seemed to work. // Notes wron on insert 10x's


                  //   // Also need to change Subject Status.
                  //   // if agent and service // SERVED 
                    if(this.gfunc.sessionUserLevel == 5 && model.subject_attempt_type_id == 1){
                      // this.updateSubjectStatus(model, "SERVED");
                      this.updateSubjectStatus(model, "SERVD");
                    }
                    //Attendance
                    if(this.gfunc.sessionUserLevel == 5 && model.subject_attempt_type_id == 2){
                      // this.updateSubjectStatus(model, "UPDRECEIVED");
                      this.updateSubjectStatus(model, "UPDREC");
                    }


                  //   // if agent and attemt //UPDRECEIVED
                    
                    
                  //   // :: @ SCRIPT SKIPS ROUT IN FUNCTION ABOVE>

                  
                    if (model.send_communications == true) {
                  this.sendAttemptCommunications(model);
                    }

                  //     /// Did not worke.
                  //     // refresh the imported subject component
                  //     // SubjectEditComponent.returned.next(false);

                  //      //  return true;
                    this.toastr.success("Subject Attempt Added: " +  model.subject_number);
                  //     // this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
     
       },
       error => {
        console.log(error.error);
         // return Observable.throw(error);
       }
  );
  }






 createSubjectService(model) {




// this.LoadSubjectserviceOutcomeTemplateParagraph(model); // test run on stave to double check always gets 

        // // double check if muiltiple to change the subjcet number
        // if(model.additional_subject != 1 ){
        // model.subject_id = this.subject_id;
        //   }

        if(model.paragraph_rendered == ''){
                this.toastr.info('Paragraph Empty:' + model.service_paragraph_rendered)
                this.LoadSubjectserviceOutcomeTemplateParagraph(model); // test run on stave to double check always gets 
                this.toastr.success('Paragraph Created:' + model.service_paragraph_rendered)
        }

// fource create the paragraphs
        // this.LoadSubjectserviceOutcomeTemplateParagraph(model); // test run on stave to double check always gets 

        // auto rate resolution of a service
        if(model.subject_attempt_type_id == 1){
          model.subject_service_resolution_outcome_id = 1;
        }
        
        if(model.subject_attempt_type_id == 2 && this.gfunc.sessionUserLevel >= 4){
          model.subject_service_resolution_outcome_id = 0;
        }



        model.job_id = this.job_id;
        model.created_by = this.sessionUserId;
        model.updated_by = this.sessionUserId; // Fix mysql errors 2025
        model.service_file_array =  JSON.stringify(model.service_file_array);
        model.is_count = this.is_count;  ///??????? do I need to change this to fix counts

        // stringify the image attachment arrays
                model.property_images =  JSON.stringify(model.property_images);
                model.property_sign_images =  JSON.stringify(model.property_sign_images);
                model.property_mail_images =  JSON.stringify(model.property_mail_images);
                model.property_vehicles_images =  JSON.stringify(model.property_vehicles_images);
                model.property_pets_images =  JSON.stringify(model.property_pets_images);
                model.property_occupancy_images =  JSON.stringify(model.property_occupancy_images);
                model.property_condition_images =  JSON.stringify(model.property_condition_images);
                model.property_type_images =  JSON.stringify(model.property_type_images);

// Set the default HTML fields before going live - HTML -- Remove this when going to new format Nov 2023
// x17 fields
if(model.general_notes_HTML == null){
      // model.general_notes_HTML = model.general_notes;
      // model.person_spoken_with_advised_HTML = model.person_spoken_with_advised
      // model.vehicles_notes_HTML = model.vehicles_notes
      // model.calling_card_notes_HTML = model.calling_card_notes
      // model.neighbours_notes_HTML = model.neighbours_notes
      // model.postal_mail_notes_HTML = model.postal_mail_notes
      // model.phone_call_notes_HTML = model.phone_call_notes
      // model.attempts_notes_HTML = model.attempts_notes
      // model.property_forsale_or_lease_sign_details_HTML = model.property_forsale_or_lease_sign_details
      // model.property_mail_details_HTML = model.property_mail_details
      // model.property_vehicles_sighted_details_HTML = model.property_vehicles_sighted_details
      // model.property_pets_details_HTML = model.property_pets_details
      // model.property_occupancy_details_HTML = model.property_occupancy_details
      // model.property_condition_HTML = model.property_condition
      // model.property_type_details_HTML = model.property_type_details
      // model.property_occupied_details_HTML = model.property_occupied_details
      // model.email_contents_HTML = model.email_contents
      // model.service_under_order_HTML = model.service_under_order
}




// These are not set yet so set them below.
// this.toastr.info('Service Method Name: ' + model.subject_service_method_name);
// this.toastr.info('Attempt Type  Name: ' + model.subject_attempt_type_name);

// look up names here to add into notes july 2022 updates
          if(model.subject_service_method_id >= 1){
                  this.getServiceMethod(model.subject_service_method_id);
          }
        if(model.subject_attempt_type_id >= 1){
        this.getSubjectAttemptType(model.subject_attempt_type_id);
        }
        // email set
        model.email_address_served = this.email_address_served; // sets from drop down

        
        // August 2023 - TimeZone Fixed Text
          // set a fixed time
          const dateTime = new Date(model.time_service).toLocaleTimeString('en-AU', {
            hour: 'numeric', minute: 'numeric', hour12: true
            });


          // this.model.time_service_text = this.mytime;
     
     
          // Commnented out to preserve time service text on save.
                 // this.model.time_service_text = dateTime;
                // model.time_service_text = dateTime;

          // Plain text Paragrap. strip the tags through a function // SEE IF THIS WORDS TO CREATE  NON formatted paragraph automatically
          model.service_paragraph_rendered_plain_text = this.removeTags(model.service_paragraph_rendered);
          
        this.prepareResolutionOutcomeAnswers(model);


        this._demoService.createSubjectService(model).subscribe(
             data => {  this.get_latest_subject_service_id = data; // this is the retuned json upon creation.
              // this.getTraceCandidateNotes(this.trace_candidate_id);
      

              // was missing and in a below script? -- was in the add note, and set the note id??????
      model.subject_service_id = this.get_latest_subject_service_id.last_insert_id; // wrong ID --- now right if moved to here.
      // this.toastr.info('Service ID: ' + model.subject_service_id )


             // CreateJob3Component.getTraceCandidateNotes();
      
             // CreateJob3Component.returned.next(false);
            ///  this.toastr.info('Service Entered!');
            // this.getSubjectServices(this.subject_id);

            // :: @ INSERT NOTE & LOG this inserts both on create.
            this.createSubjectNote(model); 

            // Also need to change Subject Status.
            // if agent and service // SERVED -- check if this is in multiple//////!!!!!!!!
            if(this.gfunc.sessionUserLevel == 5 && model.subject_attempt_type_id == 1){
              // this.updateSubjectStatus(model, "SERVED");
              this.updateSubjectStatus(model, "SERVD");
            }
            //Attendance
            if(this.gfunc.sessionUserLevel == 5 && model.subject_attempt_type_id == 2){
              // this.updateSubjectStatus(model, "UPDRECEIVED");
              this.updateSubjectStatus(model, "UPDREC");
            }


            // if agent and attemt //UPDRECEIVED
            
            
            // :: @ SCRIPT SKIPS ROUT IN FUNCTION ABOVE>

          
            if (model.send_communications == true) {
          this.sendAttemptCommunications(model);
            }
     
              /// Did not worke.
              // refresh the imported subject component
              // SubjectEditComponent.returned.next(false);

               //  return true;
            this.toastr.success("Subject Attempt Added");
    this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
           
             },
             error => {
              console.log(error.error);
               // return Observable.throw(error);
             }
        );
        }


        // Removes HTML from a sron
        // ::@ https://www.geeksforgeeks.org/how-to-strip-out-html-tags-from-a-string-using-javascript/
  removeTags(str) {
          if ((str===null) || (str===''))
              return false;
          else
              str = str.toString();
                
          // Regular expression to identify HTML tags in
          // the input string. Replacing the identified
          // HTML tag with a null string.
          return str.replace( /(<([^>]+)>)/ig, '');
      }


        updateSubjectStatus(model, status){
          model.job_id = this.job_id;

          model.job_status = status;

          this._demoService.updateSubjectStatus(model).subscribe(
            data => { // this.trace_candidate_update = data;
              // refresh the list
             // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
            this.toastr.success('Subject Status Updated');
       //     this.gfunc.insertLog_UpdateSubjectStatus(model);
            // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
            // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
         //   this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
            },
            error => {
             // console.error('Error saving Event!');
              // this.toastr.error('Error Changing Status of Subject');
             return console.log(error);
            }
           // err => console.error(err),
           // () => console.log('done updates')
        );}

        

sendSharmansEmail(model){
  // model = [];

 
  // const pushed_file = {
  //   file_name: this.created_file_name,
  //   subject_file: 1,
  //   job_file: 0,
  // }; // multidimentional array push



  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  model.push({
    job_id: this.job_id,
    subject_id: this.subject_id,
    brand_type_id: null,
    subject_number: '',
    allAttachments: '[]',
    message_subject: '',
    message_body: '',
    ...model
  });

};

sendSimpleEmial(model){
this._mysqlService.sendSimpleEmail(model).subscribe(
  (data) => {
    // this.trace_candidate_update = data;
    // this.toastr.success('Sent Email.');
    const res = data;
    console.log(res); // not working as response is showing in body
    // console.log(res._body);
    // console.log(res.text()); // Convert response to a string
    // now close the modal
    // this.closeParentModel.emit();
    // this.closeParentModel3.emit();
    // // refresh the invoice page if
    // if ( model.invoice_id > 0 ){
    //   this.refreshSujectInvoicePage.emit(this.subject_id);
    // }
  },
  (error) => {
    // this.toastr.error('Error sending Email');
   return console.log(error);
  }
);
}

// sends the communications function if set to true.
        sendAttemptCommunications(model) {
              // need to run the send communications function here./button.
              model.doc_id = 12;
              model.subject_com_type_id = 3; // 4 Affidavits
              model.job_type_id = 1; // 1  Process Serviing,
              
              // model.job_type_location_id =  3; // 3 QLD
              // model.job_type_court_id = 8; // Civil
              // model.job_type_document_type_id = 44; // 44 notice of default
              // model.job_type_affidavit_type_id = 91; // 91 attemp of services
            
            // See Global Function to See Vars
            // TODO below needs to accommodate if sending to an agent as well.
            // :: Extra Vars to Establish the send.
            model.brand_type_id = 2; // client 2 agent 3
            model.brand_report_id = model.brand_report_id; // current subject job details
            model.brand_invoice_id = model.brand_invoice_id; // current subject job details
            model.brand_work_order_id = null;
            model.send_to_invoice = null; // 1 or 0
            model.send_to_report = 1; // 1 or 0
            model.send_to_logins = 0; // 1 or 0
            model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
            model.additional_message = "Automated Email Sent: Subject Attempt Added " + this.gfunc.today;
            model.allAttachments = [];

            model.subject_id =  this.subject_id;
            model.subject_number = model.subject_number;
           
            // model.invoice_id = invoice_id,
            // model.work_order_id = work_order_id,
            
              // :: Now create the doc and email through the communication template sysstem as a global function
              this.gfunc.createDocumentButtonAndSend(model);
        };


        getSubjectServices(subject_id) {
          this._demoService.getSubjectServices(subject_id).subscribe(
            data => { this.subject_services = data;
             // console.log("Done loadng USER");
             // console.log(this.users);
             let res = data[0];
             // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
             // this.getUsersById(res.who_attended);
            },
            error => {
            //  console.error('Error Loading User!');
            // return Observable.throw(error);
            }
          ); }



          deleteSubjectService(subject_service_id) {
            if (confirm('Are you sure you want to delete this Service Information? ')) {
              this._demoService.deleteSubjectService(subject_service_id).subscribe(
                 data => {
                  this.getSubjectServices(this.subject_id);
                   return true;
                 },
                 error => {
                   console.error('Error deleting Attendence!');
                  return console.log(error);
                 }
              );
          }
          }

 

          
          getSubjectServiceOutcome(subject_service_outcome_id) {
            this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
              data => { this.subjectServiceOutcome = data; },
              err => console.error(err),
            );
            } 

            getSubjectServiceOutcomeIsCount(subject_service_outcome_id) {
              this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
                data => { this.subjectServiceOutcome = data;
                let res = data[0];
                this.is_count_subject_service_outcome_lookup = res.is_count;
                this.is_count = this.is_count_subject_service_outcome_lookup; // sets the is_count_same as drop down.
                
                },
                err => console.error(err),
              );
              } 

            getSubjectLocationStatuss() {
              this._demoService.SubjectLocationStatuss().subscribe(
                data => { this.subjectLocationStatuss = data; },
                err => console.error(err),
              );
              }

              getSubjectLocationStatussFound() {
                this._demoService.SubjectLocationStatussFound().subscribe(
                  data => { this.subjectLocationStatussFound = data; },
                  err => console.error(err),
                );
                }

                // for select items
                onSelectionChange(entry) {
                 // this.selectedEntry = entry;
                  this.model.subject_location_status_found_id = entry; // changes or updates via selection of radio button group
                  this.attemptForm.controls['subject_location_status_found_id'].setValue(entry);
                }


                // for select items
                onSelectionChangeVehicles(entry) {
                // this.selectedEntry = entry;
                this.model.vehicles = entry; // changes or updates via selection of radio button group
               // this.model.vehicles_notes = 'here are my notes.'
              }
              // for select items
              onSelectionChangeNeighbours(entry) {
                // this.selectedEntry = entry;
                  this.model.neighbours = entry; // changes or updates via selection of radio button group
                }
                onSelectionChangeCallingCard(entry) {
                  // this.selectedEntry = entry;
                    this.model.calling_card = entry; // changes or updates via selection of radio button group
                  };
                  onSelectionChangeMail(entry) {
                    // this.selectedEntry = entry;
                      this.model.postal_mail = entry; // changes or updates via selection of radio button group
                    }
                    onSelectionChangePhoneCall(entry) {
                      // this.selectedEntry = entry;
                        this.model.phone_call = entry; // changes or updates via selection of radio button group
                      }
                      onSelectionChangeAttempts(entry) {
                        // this.selectedEntry = entry;
                          this.model.attempts = entry; // changes or updates via selection of radio button group
                      // updated to run the parag reation at the attempts entry
                      this.LoadSubjectserviceOutcomeTemplateParagraph(this.model);

                        }
                        onSelectionChangePersonType(entry) {
                          // this.selectedEntry = entry;
                            this.model.person_type = entry; // changes or updates via selection of radio button group
                          }
                


                          clearChecked(field, model){
                           model.vehicles = false;
                           model.vehicles_notes = null;
                          // this.attemptForm.controls['radiogroup2'].setValue(null);
                          // this.attemptForm.setValue({radiogroup2: '', radiogroup3: true});
                          }
                          clearCheckedNeighbours(field, model){ model.neighbours = false; model.neighbours_notes = null;}
                          clearCheckedCallingCard(model){ model.calling_card = false; model.calling_card_notes = null;}
                          clearCheckedPostalMail(model){ model.postal_mail = false; model.mail_notes = null;}
                          clearCheckedPhoneCall(model){ model.phone_call = false; model.phone_call_notes = null;}
                          clearCheckedAttempts(model){ model.attempts = false; model.attempts_notes = null;}
                          clearCheckedPersonType(model){ model.person_type = false; model.person_type_notes = null;}
                          clearCheckedResolutions(model){
                            model.subject_service_resolution_outcome_id = null;
                            model.subject_service_resolution_outcome_type_answer_array = null;
                            this.resolutionOutcomeAnswersByType = {};
                          }


        // for select items
        onChangeServiceCount(model, who_service_value) {
          this.model.service_number = 0;   
          model.job_id = this.job_id;
          model.subject_id = this.subject_id;

        // look (count) up job_id, subject_id, agent id attendences + 1
        this.getJobSubjectAttendancesCountNumber(model);
        // set model.service_number = results.

        // This function removes the unwanted agents from the allRecpients list when creating service and choosing agent.
        console.log('who_service_value: ', who_service_value);

        // reset or reload incase the drop down changes.
        // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.
        this.RemoveElementOthersFromAllRecipients(who_service_value);
        

        }



        // for select items
        onChangeServiceCountSubjectArray(model, who_service_value) {
          this.model.service_number = 0;   
          model.job_id = this.job_id;
          // model.subject_id = this.subject_id;
          
        // look (count) up job_id, subject_id, agent id attendences + 1
        this.getJobSubjectAttendancesCountNumber(model);
        // set model.service_number = results.

        // This function removes the unwanted agents from the allRecpients list when creating service and choosing agent.
        console.log('who_service_value: ', who_service_value);

        // reset or reload incase the drop down changes.
        // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.
        this.RemoveElementOthersFromAllRecipients(who_service_value);
        

        }



                 getJobSubjectAttendancesCountNumber(model){
                  this._demoService.getJobSubjectAttendancesCountNumber(model).subscribe(
                    data => { this.current_service_number = data; 
                      this.converted_service_number = Number(this.current_service_number);
                                        // this.selectedEntry = entry;
                
                 if(this.is_count == 1){    
                 let increment = Number(this.converted_service_number + 1);
                  this.model.service_number = increment; // changes or updates via selection of radio button group
                this.model.is_count = this.is_count; 
                }
                 if(this.is_count == 0){
                  this.model.service_number = this.converted_service_number;
                  this.model.is_count = this.is_count; 
                 }

                      // console.log(data);
                    },
                    err => {
                      // console.error(err)
                      // set to one if there is an error because it means subject id cannot be found
                      if(this.is_count == 0){
                      this.model.service_number = 0;
                      }
                      if(this.is_count == 1){
                        this.model.service_number = 1;
                      }

                    },
                  );

                 }



                 // Change all this to output to return the number.

                 getJobSubjectAttendancesCountNumberFromModdal(sent_model){
                  this._demoService.getJobSubjectAttendancesCountNumber(sent_model).subscribe(
                    data => { this.current_service_number_multiple = data; 
                    
                      this.converted_service_number_muliple = Number(this.current_service_number_multiple);
                                        // this.selectedEntry = entry;
                
                                        let is_count = this.is_count;
                                        let return_count = 0;

                 if(is_count == 1){    
                 let increment = Number(this.converted_service_number_muliple + 1);
                //  this.model.service_number = increment; // changes or updates via selection of radio button group
               // this.model.is_count = this.is_count; 

                  return_count = increment;
                }
                 if(is_count == 0){
                  // this.model.service_number = this.converted_service_number_muliple;
                  // this.model.is_count = this.is_count; 

                  return_count = this.converted_service_number_muliple
                 }


                 return  return_count;
                      // console.log(data);
                    },
                    err => {
                      // console.error(err)
                      // set to one if there is an error because it means subject id cannot be found
                      if(this.is_count == 0){
                      // this.model.service_number = 0;
                      return 0;
                      }
                      if(this.is_count == 1){
                        // this.model.service_number = 1;
                        return 1;
                      }

                    },
                  );

                 }


// :: Attempts - 2022 Upgrades

                 //:: Set the label for all naming conventions
setAttemptType(model) {
    this.subject_attempt_type_label = (<HTMLSelectElement>document.getElementById('subject_attempt_type_id')).selectedOptions[0].text;
    console.log('Attempt Type Task: ' +  this.subject_attempt_type_label);
  //  const doc_name = document.getElementById('doc_name').innerText;
  //  console.log('Document Name: ' +  doc_name);


// need new function to filter the results of the drop down "subject_outcomes_of_service - for attemps only"
// ... reset the drop down objects1 // attendance
if (model.subject_attempt_type_id == 2) {
console.log(' ... Filtering Outcomes');
this.serviceOutcomes_filtered = this.serviceOutcomes.filter((sbi) => (sbi.subject_attempt_type_id === '2')); // only grabs onoe.
// const result = this.serviceOutcomes.filter(s => s.includes('val'));
this.serviceOutcomes = this.serviceOutcomes_filtered;
// console.log(' ... Filtering Outcomes ' + JSON.stringify(this.serviceOutcomes_filtered));
// set the defaults for entering attemps.
// this.model.subject_service_outcome_id = 8; // outcome default is not-served (New_).
// this.attemptForm.controls['subject_service_outcome_id'].setValue(8); // double in case the form needs setting.

this.model.subject_service_outcome_id = 1000; // outcome default is not-served (New_).
this.attemptForm.controls['subject_service_outcome_id'].setValue('1000'); // double in case the form needs setting.

}else {
//  this.getServiceOutcomes(); // reset the menu
this.getServiceOutcomesAccessLevel(this.gfunc.sessionUserLevel)
} // end if attempt type 2




  // :: Set Some Defaults -- make these hidden fields to stop the javascript errors.
  // Attempt - Servive
  if (model.subject_attempt_type_id == 1 ){
    this.model.subject_service_outcome_id = 1; // outcome default is served.
    this.attemptForm.controls['subject_service_outcome_id'].setValue('1');
    this.attemptForm.controls['subject_location_status_id'].setValue('0'); // to prevent printing in templates when not required.
    this.attemptForm.controls['subject_location_status_found_id'].setValue(0); // to prevent printing in templates when not required.
    this.is_count= 1; // aways count if if a service.
  }



}

// pull the selected attempt Outcome drop down name.
setOutcomeType(model) {
  this.subject_outcome_type_label = (<HTMLSelectElement>document.getElementById('subject_service_outcome_id')).selectedOptions[0].text;
  console.log('Outcome Type Task: ' +  this.subject_outcome_type_label);

  this.getSubjectServiceOutcomeIsCount(model.subject_service_outcome_id); // sets the is_couunt.
  if(model.who_service >=1){
    this.onChangeServiceCount(model, model.who_service_value); 
  }

}

switchFormValidationRuleFalseRequired(){
  if (confirm('Skip all below and mark as not applicale or not relevent ')) {
  this.form_validator_switch_value = false;
  }
}

confirmOptionalFieldsToggle(isOpen: boolean, label: string): boolean {
  const message = isOpen
    ? `Hide ${label} and mark the fields below as not applicable for this entry?`
    : `Show ${label}. You will need to complete the relevant fields below for this entry.`;

  return confirm(message);
}



setEmailAddressServed(model) {
  this.email_address_served = (<HTMLSelectElement>document.getElementById('subject_contact_email_id')).selectedOptions[0].text;
  console.log('Email Selected: ' +  this.email_address_served);

// only set if not the descriptor.
  if (this.email_address_served != '-- choose or enter --') {
  this.model.email_address_served = this.email_address_served; // sets the field so it can be entered or selected
  }else {
    this.model.email_address_served = null;
  }

  //  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);
}


setPhoneNumber(model) {
  this.phone_number = (<HTMLSelectElement>document.getElementById('subject_contact_number_id')).selectedOptions[0].text;
  console.log('Phone Number Selected: ' +  this.phone_number);

// only set if not the descriptor.
  if (this.phone_number != '-- choose or enter --') {
  this.model.phone_number = this.phone_number; // sets the field so it can be entered or selected
  }else {
    this.model.phone_number = null;
  }

  //  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);
}


prepareAttemptAutomationContext(model) {
  const subject = model.subject_model || this.subject_model || {};
  const clean = value => value === undefined || value === null ? '' : String(value).trim();
  const copySubjectField = field => {
    if (clean(model[field]) === '' && clean(subject[field]) !== '') {
      model[field] = subject[field];
    }
  };
  const lookupLabel = (items, idField, labelField, selectedId) => {
    if (!Array.isArray(items)) {
      return '';
    }
    const selected = items.find(item => String(item[idField]) === String(selectedId));
    return selected ? clean(selected[labelField]) : '';
  };

  ['title', 'first_name', 'middle_name', 'surname', 'business_name'].forEach(copySubjectField);

  const businessName = clean(model.business_name);
  const personName = [model.title, model.first_name, model.middle_name, model.surname]
    .map(clean)
    .filter(value => value !== '')
    .join(' ');
  model.subject_name = businessName || personName;
  this.subject_name = model.subject_name;

  model.subject_attempt_type_name = lookupLabel(
    this.subjectAttemptTypesList,
    'subject_attempt_type_id',
    'subject_attempt_type_name',
    model.subject_attempt_type_id
  ) || clean(model.subject_attempt_type_name)
    || clean(this.subject_attempt_type_name)
    || clean(this.subject_attempt_type_label)
    || (Number(model.subject_attempt_type_id) === 1 ? 'Service' : 'Attendance');
  this.subject_attempt_type_name = model.subject_attempt_type_name;

  model.subject_service_method_name = lookupLabel(
    this.serviceMethods,
    'subject_service_method_id',
    'service_method_name',
    model.subject_service_method_id
  ) || clean(model.subject_service_method_name) || clean(this.subject_service_method_name);
  this.subject_service_method_name = model.subject_service_method_name;

  model.subject_outcome_type_label = lookupLabel(
    this.serviceOutcomes,
    'subject_service_outcome_id',
    'service_outcome_name',
    model.subject_service_outcome_id
  ) || clean(model.subject_outcome_type_label) || clean(this.subject_outcome_type_label);
  this.subject_outcome_type_label = model.subject_outcome_type_label;
}


buildAttemptNoteContent(model, fullDateTimeOfService) {
  const clean = value => value === undefined || value === null ? '' : String(value).trim();
  const resultName = Number(model.subject_attempt_type_id) === 1
    ? model.subject_service_method_name
    : model.subject_outcome_type_label;
  const summary = [model.subject_number, model.subject_attempt_type_name, resultName]
    .map(clean)
    .filter(value => value !== '')
    .join(' ');

  return summary + ' - ' + clean(fullDateTimeOfService);
}



//October 2023 :: Model being sent for automation was simply the note, needed to be a full model of the event created, so that auomations will work and variables available.
// Create New Type of note:
// this is an agent note.
createSubjectNote(model) {
 // ... need to look up service type name and service method names. to put in mmodel.
//  this.getServiceMethod(model.subject_service_method_id);
//  this.getSubjectAttemptType(model.subject_attempt_type_id);

// commented these out for mulit-subject array
  // model.subject_id = this.subject_id;
  // model.job_id = this.job_id;


  model.created_by = this.gfunc.sessionUserId;
  model.note_type_id = 8; // is note added.
  model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
  // model.brand_type_id = this.gfunc.sessionBrandTypeId;

 model.subject_com_type_id = null;
 model.subject_template_doc_id = null;
 model.file_id = null;
 model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
 model.brand_id = this.gfunc.sessionBrandId;

 model.subject_number = this.model.subject_number;
 model.reference_number = this.model.reference_number;
 model.job_reference_number = '1'; // will always be one as there are not job stages.
 model.file_number = this.model.file_number;

 this.prepareAttemptAutomationContext(model);


// Mught need to rewrite the function if a multiple to put the correct details of current. (use model,? or re-loop the details below)

   // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
   model.created_by = this.sessionUserId;
   // tslint:disable-next-line:max-line-length


let  full_date_time_of_service =   model.time_service_text + ' ' + moment(model.date_service).format('dddd MMMM Do, YYYY')


if (model.subject_attempt_type_id == 1){
  //  model.note_content = this.model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_service_method_name + ' - ' + model.date_service;
  // model.note_content = model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_service_method_name + ' - ' + model.date_service;

  
  model.note_content = this.buildAttemptNoteContent(model, full_date_time_of_service);
  //  model.note_content = model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_service_method_name + ' - ' + model.date_service;


     //  'Attempt for Subject Entered:' + this.model.subject_number;
   }

   
if (model.subject_attempt_type_id == 2){
  // tslint:disable-next-line:max-line-length
  // model.note_content = this.model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_outcome_type_label + ' - ' + model.date_service;
  // model.note_content = model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_outcome_type_label + ' - ' + model.date_service;
  
  
  model.note_content = this.buildAttemptNoteContent(model, full_date_time_of_service);
  //  model.note_content = model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_outcome_type_label + ' - ' + model.date_service;

   
  //  'Attempt for Subject Entered:' + this.model.subject_number;
  }
   
     model.note_type_id = '8';
          // set for notice and log
                      // orignal before october 2023
        //   model = {
        //   note_content: model.note_content, // the message that appears in the note
        //   created_by: this.gfunc.sessionUserId,
        //   created_date: this.gfunc.today,
        //   subject_id: model.subject_id, // who the note was specifically created for subject
        //   job_id: model.job_id, // job note was created for
        //   job_reference_number: model.job_reference_number, // job reference number eg. 100.1
        //   file_number: model.file_number, // the file number for the stage system eg. 1
        //   reference_number: model.reference_number, // the subject reference number - last number in subject number .4
        //   subject_number: model.subject_number, // exact subject number eg 1001.2.1
        //   note_type_id: 8, // see database table for subject_note_types
        //   user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
        //   brand_type_id: 3, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
        //   subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
        //   subject_template_doc_id: model.subject_template_doc_id, // if a template was used
        //   file_id: model.file_id,
        //   brand_id: model.brand_id, // the brand ofd the company who created the note
        //   assigned_to_agents: JSON.stringify(this.allRecipients), // new assinged to agents data for notes
        //   subject_attempt_type_name: this.subject_attempt_type_name,
        //   subject_name: model.subject_name
        // };


        // this.model = model; // maybe just incase

// :: October 2023
// October 2023 :: Model being sent for automation was simply the note, needed to be a full model of the event created, so that auomations will work and variables available.

  let note_model = {

    ...model, // the original event/action model of the attemopt creation

  note_content: model.note_content, // the message that appears in the note
  created_by: this.gfunc.sessionUserId,
  updated_by: this.gfunc.sessionUserId, // CASUNG MYSQL ERRORS on file creation in automations MAY 2025
  created_date: this.gfunc.today,
  subject_id: model.subject_id, // who the note was specifically created for subject
  job_id: model.job_id, // job note was created for
  job_reference_number: model.job_reference_number, // job reference number eg. 100.1
  file_number: model.file_number, // the file number for the stage system eg. 1
  reference_number: model.reference_number, // the subject reference number - last number in subject number .4
  subject_number: model.subject_number, // exact subject number eg 1001.2.1
  note_type_id: 8, // see database table for subject_note_types
  user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
  brand_type_id: 3, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
  subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
  subject_template_doc_id: model.subject_template_doc_id, // if a template was used
  file_id: model.file_id,
  brand_id: model.brand_id, // the brand ofd the company who created the note
  assigned_to_agents: JSON.stringify(this.allRecipients), // new assinged to agents data for notes
  subject_attempt_type_name: this.subject_attempt_type_name,
  subject_name: model.subject_name

};

  // now comingns both models
  model = note_model; // maybe just incase

// :: !!! @ log is also inserted now when we insert the note function
  // if (result.job_status === 'OPEN'){
  this._demoService.createSubjectNote(model).subscribe(
    (data) => {
      this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
      let res2 = data[0];
      // set the note_id to insert into the log.
      model.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
      // Octoner 2023 Set this so that I can grab the attempt variables for the automations if this is set in call.
     
     
      // moved to the service.
      // model.subject_service_id = this.get_latest_subject_note_id.last_insert_id; // wrong ID --- this is the noteID>...
     
      // :: Insert the LOG in same step.
      this.gfunc.insertLog_CreateSubjectAttempt(model);
    
        // add two now log types for tracking and leave automations to attempt_added.
        //subject_attendance_added
        if(model.subject_attempt_type_id == 1 ){
        this.gfunc.insertLog_CreateSubjectAttempt_Service(model);
        }
        //subject_service_added
        if(model.subject_attempt_type_id == 2 ){
          this.gfunc.insertLog_CreateSubjectAttempt_Attendance(model);

        // 2026 -- New Dynamic Granual Logs For each SSOT - dynaically logged. (Attendance + Service but testing on attendances)  
        this.gfunc.insertLog_CreateSubjectAttempt_Attendance_type(model)

        }
    
    
      // this.gfunc.insertLog_CreateSubjectAttempt(note_model);

      // :: Now refresh the entire subject page.
      // :: October 2023 commented out for test in the refresh.
      this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
       this.closeParentModel.emit();

      //  this.toastr.info('Attempt Entered & Data Saved!');
      // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
      // this.search_results[objIndex].note_added = 'yes';
    },
    (error) => {
     console.log(error(error));
      // return Observable.throw(error);
      
    }
  );
  // } // end if  open
}



createSubjectNoteMultipleNew(model) {
  // ... need to look up service type name and service method names. to put in mmodel.
 //  this.getServiceMethod(model.subject_service_method_id);
 //  this.getSubjectAttemptType(model.subject_attempt_type_id);
 
 // commented these out for mulit-subject array
   // model.subject_id = this.subject_id;
   // model.job_id = this.job_id;
 
 
   model.created_by = this.gfunc.sessionUserId;
   model.note_type_id = 8; // is note added.
   model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
   // model.brand_type_id = this.gfunc.sessionBrandTypeId;
 
  model.subject_com_type_id = null;
  model.subject_template_doc_id = null;
  model.file_id = null;
  model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
  model.brand_id = this.gfunc.sessionBrandId;
 
  model.subject_number = model.subject_number;
  model.reference_number = model.reference_number;
  model.job_reference_number = '1'; // will always be one as there are not job stages.
  model.file_number = model.file_number;

  this.prepareAttemptAutomationContext(model);
 
 
 // Mught need to rewrite the function if a multiple to put the correct details of current. (use model,? or re-loop the details below)
 
    // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
    model.created_by = this.sessionUserId;
    // tslint:disable-next-line:max-line-length
 

let  full_date_time_of_service =   model.time_service_text + ' ' + moment(model.date_service).format('dddd MMMM Do, YYYY')

 if (model.subject_attempt_type_id == 1){
   //  model.note_content = this.model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_service_method_name + ' - ' + model.date_service;
  //  model.note_content = model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_service_method_name + ' - ' + model.date_service;

   model.note_content = this.buildAttemptNoteContent(model, full_date_time_of_service);
 
      //  'Attempt for Subject Entered:' + this.model.subject_number;
    }
 
    
 if (model.subject_attempt_type_id == 2){
   // tslint:disable-next-line:max-line-length
   // model.note_content = this.model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_outcome_type_label + ' - ' + model.date_service;
  //  model.note_content = model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_outcome_type_label + ' - ' + model.date_service;

   model.note_content = this.buildAttemptNoteContent(model, full_date_time_of_service);
    
   //  'Attempt for Subject Entered:' + this.model.subject_number;
   }
    
      model.note_type_id = '8';
           // set for notice and log
                       // orignal before october 2023
         //   model = {
         //   note_content: model.note_content, // the message that appears in the note
         //   created_by: this.gfunc.sessionUserId,
         //   created_date: this.gfunc.today,
         //   subject_id: model.subject_id, // who the note was specifically created for subject
         //   job_id: model.job_id, // job note was created for
         //   job_reference_number: model.job_reference_number, // job reference number eg. 100.1
         //   file_number: model.file_number, // the file number for the stage system eg. 1
         //   reference_number: model.reference_number, // the subject reference number - last number in subject number .4
         //   subject_number: model.subject_number, // exact subject number eg 1001.2.1
         //   note_type_id: 8, // see database table for subject_note_types
         //   user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
         //   brand_type_id: 3, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
         //   subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
         //   subject_template_doc_id: model.subject_template_doc_id, // if a template was used
         //   file_id: model.file_id,
         //   brand_id: model.brand_id, // the brand ofd the company who created the note
         //   assigned_to_agents: JSON.stringify(this.allRecipients), // new assinged to agents data for notes
         //   subject_attempt_type_name: this.subject_attempt_type_name,
         //   subject_name: model.subject_name
         // };
 
 
         // this.model = model; // maybe just incase
 
 // :: October 2023
 // October 2023 :: Model being sent for automation was simply the note, needed to be a full model of the event created, so that auomations will work and variables available.
 
   let note_model = {
 
     ...model, // the original event/action model of the attemopt creation
 
   note_content: model.note_content, // the message that appears in the note
   created_by: this.gfunc.sessionUserId,
   created_date: this.gfunc.today,
   subject_id: model.subject_id, // who the note was specifically created for subject
   job_id: model.job_id, // job note was created for
   job_reference_number: model.job_reference_number, // job reference number eg. 100.1
   file_number: model.file_number, // the file number for the stage system eg. 1
   reference_number: model.reference_number, // the subject reference number - last number in subject number .4
   subject_number: model.subject_number, // exact subject number eg 1001.2.1
   note_type_id: 8, // see database table for subject_note_types
   user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
   brand_type_id: 3, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
   subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
   subject_template_doc_id: model.subject_template_doc_id, // if a template was used
   file_id: model.file_id,
   brand_id: model.brand_id, // the brand ofd the company who created the note
   assigned_to_agents: JSON.stringify(this.allRecipients), // new assinged to agents data for notes
   subject_attempt_type_name: model.subject_attempt_type_name,
   subject_name: model.subject_name
 
 };
 
   // now comingns both models
   model = note_model; // maybe just incase // wass using model... see if this changes... tthe data to be correctl...

   let new_note_model = note_model
 
 // :: !!! @ log is also inserted now when we insert the note function
   // if (result.job_status === 'OPEN'){
   this._demoService.createSubjectNote(new_note_model).subscribe(
     (data) => {
       this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
       let res2 = data[0];
       // set the note_id to insert into the log.
       new_note_model.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
       // Octoner 2023 Set this so that I can grab the attempt variables for the automations if this is set in call.
       new_note_model.subject_service_id = this.get_latest_subject_note_id.last_insert_id; // wrong ID --- this is the noteID>...
       // :: Insert the LOG in same step.
       this.gfunc.insertLog_CreateSubjectAttempt(new_note_model);
       // this.gfunc.insertLog_CreateSubjectAttempt(note_model);
 
       // :: Now refresh the entire subject page.
       // :: October 2023 commented out for test in the refresh.
       // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
       //  this.closeParentModel.emit();
 
       //  this.toastr.info('Attempt Entered & Data Saved!');
       // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
       // this.search_results[objIndex].note_added = 'yes';
     },
     (error) => {
      console.log(error(error));
       // return Observable.throw(error);
     }
   );
   // } // end if  open
 }
 
 
 

async createSubjectNoteMultiple(model, get_latest_subject_service_id) {
  // ... need to look up service type name and service method names. to put in mmodel.
 //  this.getServiceMethod(model.subject_service_method_id);
 //  this.getSubjectAttemptType(model.subject_attempt_type_id);
 
 // commented these out for mulit-subject array
   // model.subject_id = this.subject_id;
   // model.job_id = this.job_id;
 
console.log('Nate Latest Service ID:' + get_latest_subject_service_id);

 
   model.created_by = this.gfunc.sessionUserId;
   model.note_type_id = 8; // is note added.
   model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
   // model.brand_type_id = this.gfunc.sessionBrandTypeId;
 
  model.subject_com_type_id = null;
  model.subject_template_doc_id = null;
  model.file_id = null;
  model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
  model.brand_id = this.gfunc.sessionBrandId;
 


  /// changed from this.... and get directly from the model.
  model.subject_number = model.subject_number;
  model.reference_number = model.reference_number;
  model.job_reference_number = '1'; // will always be one as there are not job stages.
  model.file_number = model.file_number;

  this.prepareAttemptAutomationContext(model);
 
 
 // Mught need to rewrite the function if a multiple to put the correct details of current. (use model,? or re-loop the details below)
 
    // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
    model.created_by = this.sessionUserId;
    // tslint:disable-next-line:max-line-length
 
 if (model.subject_attempt_type_id == 1){
   //  model.note_content = this.model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_service_method_name + ' - ' + model.date_service;
   model.note_content = this.buildAttemptNoteContent(model, model.date_service);
 
      //  'Attempt for Subject Entered:' + this.model.subject_number;
    }
 
    
 if (model.subject_attempt_type_id == 2){
   // tslint:disable-next-line:max-line-length
   // model.note_content = this.model.subject_number + ' ' + this.subject_attempt_type_name + ' ' + this.subject_outcome_type_label + ' - ' + model.date_service;
   model.note_content = this.buildAttemptNoteContent(model, model.date_service);
    
   //  'Attempt for Subject Entered:' + this.model.subject_number;
   }
    
      model.note_type_id = '8';
           // set for notice and log
  //  setTimeout(() => {   


     // :: October 2023
 // October 2023 :: Model being sent for automation was simply the note, needed to be a full model of the event created, so that auomations will work and variables available.

 this.model2 = {};



 // multiple bug... needs fixing october 9 2023
 // we need to update the service by looking up the next subject and adding thier details like subject ID number etc... as the model being passed to the automations and logs is the saved model from the attempt entry which sends ass the entry variables not the next in the loop

   this.model2 = {

  
   ...model, // the original event/action model of the attemopt creation
    
   note_content: model.note_content, // the message that appears in the note
   created_by: this.gfunc.sessionUserId,
   created_date: this.gfunc.today,
   subject_id: model.subject_id, // who the note was specifically created for subject
   job_id: model.job_id, // job note was created for
   job_reference_number: model.job_reference_number, // job reference number eg. 100.1
   file_number: model.file_number, // the file number for the stage system eg. 1
   reference_number: model.reference_number, // the subject reference number - last number in subject number .4
   subject_number: model.subject_number, // exact subject number eg 1001.2.1
   note_type_id: 8, // see database table for subject_note_types
   user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
   brand_type_id: 3, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
   subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
   subject_template_doc_id: model.subject_template_doc_id, // if a template was used
   file_id: model.file_id,
   brand_id: model.brand_id, // the brand ofd the company who created the note
   assigned_to_agents: JSON.stringify(this.allRecipients), // new assinged to agents data for notes
   subject_attempt_type_name: this.subject_attempt_type_name,
   subject_name: model.subject_name,





 };
 
//  this.model = model; // maybe just incase
 
 // :: !!! @ log is also inserted now when we insert the note function
   // if (result.job_status === 'OPEN'){

        //  // new way of automations and logtigger for multiple
        //  this._demoService.getSubjectService(get_latest_subject_service_id).subscribe(
        //   data => { let latest_service = data;


        //                this.gfunc.insertLog_CreateSubjectAttempt(latest_service[0] );


        //     // this.toastr.info('Subject Contact Email Added');
        //     // this.closeParentModel.emit();
        //     return
        //   }
        //   // ,
        //   // err => console.error(err),
        //   // // () => console.log('done loading Trace Types')
        // );




   this._demoService.createSubjectNote(this.model2).subscribe(
     (data) => {
       this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
       let res2 = data[0];
       // set the note_id to insert into the log.
       this.model2.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
       // :: Insert the LOG in same step.
      model.subject_service_id = get_latest_subject_service_id; // new way with correct latest subject service insert


      //  // need to lookup model based on the new sent ID get_latest_subject_service_id/ subject_Service_id - then do the automation from this loaded model... should work.
                 this.gfunc.insertLog_CreateSubjectAttempt(this.model2 );
    
    
       // :: Now refresh the entire subject page.
               // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
               // this.closeParentModel.emit();
 
       //  this.toastr.info('Attempt Entered & Data Saved!');
       // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
       // this.search_results[objIndex].note_added = 'yes';

       return;
     }
    //  },
    //  (error) => {
    //   console.log(error(error));
    //    // return Observable.throw(error);
    //  }
   );



   console.log("Now Ready to load...");
  // }, 0);  // was 1100


  // this.gfunc.insertLog_CreateSubjectAttempt(this.model2);



   // } // end if  open
 }
 



getServiceMethod(subject_service_method_id) {
  this._demoService.getServiceMethod(subject_service_method_id).subscribe(
    data => { this.serviceMethod = data;
    let res = data[0];
    this.subject_service_method_name = res.service_method_name;
    },
    err => console.error(err),
  );
  }
  getSubjectAttemptType(subject_service_type_id) {
    this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
      data => { this.subjectAttemptType = data;
      let res = data[0];
      this.subject_attempt_type_name = res.subject_attempt_type_name;
      },
      err => console.error(err),
    );
    }

RemoveElementOthersFromAllRecipients(key: number) {
  // test! -- load again an then filter and create the array again.
  // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

  // delay load slightly so I can refresh the allRecpientList first.
  setTimeout(function() {
}, 2000);
    console.log('Ready to clean array!')

  let array = this.allRecipients;
  // removes all not matching
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
    this.allRecipients.forEach((value, index) => {
    if (value.recipient_brand_id !== key) {
      this.allRecipients.splice(index, 1);
    }
  });
  console.log('allRecipients after Removal Others: ', JSON.stringify(this.allRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.



};


RemoveElementFromAllRecipients(key: number) {


  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  // hint: change the value."" to the row name you wish to compare.
  this.allRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};






getSubjectContactEmails(subject_id) {
  this._demoService.getSubjectContactEmails(subject_id).subscribe(
     data => { this.subject_contact_emails = data; 
    let res = data[0];
     // this.model.email_address_served = res.subject_contact_email_address; // sets from drop down
    },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }


 deleteSubjectContactEmail(subject_contact_email_id) {
  if (confirm('Are you sure you want to remove this subject contact email? ')) {
  this._demoService.deleteSubjectContactEmail(subject_contact_email_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
      this.getSubjectContactEmails(this.subject_id);
      // this.toastr.success('Subject Contact Email Removed');
       },
     err => console.error(err),
      () => {
      //  console.log('done loading SR');
                    }
        );
 }
}




onAdd(data) {
  // if (confirm('Are you sure you want to Attatch this file? ')) {
   // this.selectedFeatures.push(fileName);
    // push to global array

    // it must be an object sent - this now works as set from an attempt upload skipping across two components
if(data.file_job_id == null){
  data = data[0];
}

// else leave as is from the button grid object with "index"


console.log('Passed Data: ', JSON.stringify(data));
// let data2 = data[0];
// console.log('Send Subject ID: ' + data2.file_subject_id + ' JObID: ' + data2.file_job_id);

console.log('Send Subject ID: ' + data.file_subject_id + ' JObID: ' + data.file_job_id);

                  if (data.file_subject_id  >= 1) {
                    this.set_job_file = 0;
                    this.set_subject_file = 1;
                  }

                  if (data.file_subject_id  <= 0) {
                    this.set_job_file = 1;
                    this.set_subject_file = 0;
                  }

                  // this.allAttachedFiles.push(data.fileName);
                  this.allAttachments.push({
                    file_name: data.full_file_name,
                    job_file: this.set_job_file,
                    subject_file: this.set_subject_file,
                    file_id: data.file_id,
                    file_server_location: data.file_server_location,
                    file_ext: data.file_ext,
                    file_brand_id: data.file_brand_id,
                    file_access_level: data.file_access_level,
                    // assigned_to_agents: JSON.parse(data.assigned_to_agents), // needs to be converted to json to work when saving in full attempt  array
                    assigned_to_agents: data.assigned_to_agents, // needs to be converted to json to work when saving in full attempt  array
                   
                    // assigned_to_agents: '[]',
                    brand_type_id: data.brand_type_id
                  });

              this.allAttachments = this.allAttachments;
              this.model.service_file_array = this.allAttachments; // sets sthe model.

              // this.model.allAttachedFiles = this.allAttachedFiles;
              // this.model.allAttachments = this.allAttachments;

              this.toastr.success('File Attached ;)');


// mame of the array varairable
if (data.attach_file_array_name == 'property_images'){
 console.log('attached_file_array_name: ', data.attach_file_array_name);
 
  this.property_images.push({
                file_name: data.full_file_name,
                job_file: this.set_job_file,
                subject_file: this.set_subject_file,
                file_id: data.file_id,
                file_server_location: data.file_server_location,
                file_ext: data.file_ext,
                file_brand_id: data.file_brand_id,
                file_access_level: data.file_access_level,
                assigned_to_agents: data.assigned_to_agents,
                // assigned_to_agents: '[]',
                brand_type_id: data.brand_type_id
              });
              this.property_images = this.property_images;
              this.model.property_images = this.property_images; // sets sthe model.
         };


// mame of the array varairable
if (data.attach_file_array_name == 'property_sign_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
   this.property_sign_images.push({
                 file_name: data.full_file_name,
                 job_file: this.set_job_file,
                 subject_file: this.set_subject_file,
                 file_id: data.file_id,
                 file_server_location: data.file_server_location,
                 file_ext: data.file_ext,
                 file_brand_id: data.file_brand_id,
                 file_access_level: data.file_access_level,
                 assigned_to_agents: data.assigned_to_agents,
                // assigned_to_agents: '[]',
                 brand_type_id: data.brand_type_id
               });
               this.property_sign_images = this.property_sign_images;
               this.model.property_sign_images = this.property_sign_images; // sets sthe model.
          };         
if (data.attach_file_array_name == 'property_mail_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
    this.property_mail_images.push({
                  file_name: data.full_file_name,
                  job_file: this.set_job_file,
                  subject_file: this.set_subject_file,
                  file_id: data.file_id,
                  file_server_location: data.file_server_location,
                  file_ext: data.file_ext,
                  file_brand_id: data.file_brand_id,
                  file_access_level: data.file_access_level,
                  assigned_to_agents: data.assigned_to_agents,
                  // assigned_to_agents: '[]',
                  brand_type_id: data.brand_type_id
                });
                this.property_mail_images = this.property_mail_images;
                this.model.property_mail_images = this.property_mail_images; // sets sthe model.
          };
if (data.attach_file_array_name == 'property_vehicles_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
    this.property_vehicles_images.push({
                  file_name: data.full_file_name,
                  job_file: this.set_job_file,
                  subject_file: this.set_subject_file,
                  file_id: data.file_id,
                  file_server_location: data.file_server_location,
                  file_ext: data.file_ext,
                  file_brand_id: data.file_brand_id,
                  file_access_level: data.file_access_level,
                  assigned_to_agents: data.assigned_to_agents,
                  brand_type_id: data.brand_type_id
                });
                this.property_vehicles_images = this.property_vehicles_images;
                this.model.property_vehicles_images = this.property_vehicles_images; // sets sthe model.
          };                   
if (data.attach_file_array_name == 'property_pets_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
    this.property_pets_images.push({
                  file_name: data.full_file_name,
                  job_file: this.set_job_file,
                  subject_file: this.set_subject_file,
                  file_id: data.file_id,
                  file_server_location: data.file_server_location,
                  file_ext: data.file_ext,
                  file_brand_id: data.file_brand_id,
                  file_access_level: data.file_access_level,
                  assigned_to_agents: data.assigned_to_agents,
                  // assigned_to_agents: '[]',
                  brand_type_id: data.brand_type_id
                });
                this.property_pets_images = this.property_pets_images;
                this.model.property_pets_images = this.property_pets_images; // sets sthe model.
          };                   
if (data.attach_file_array_name == 'property_occupancy_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
    this.property_occupancy_images.push({
                  file_name: data.full_file_name,
                  job_file: this.set_job_file,
                  subject_file: this.set_subject_file,
                  file_id: data.file_id,
                  file_server_location: data.file_server_location,
                  file_ext: data.file_ext,
                  file_brand_id: data.file_brand_id,
                  file_access_level: data.file_access_level,
                  assigned_to_agents: data.assigned_to_agents,
                  // assigned_to_agents: '[]',
                  brand_type_id: data.brand_type_id
                });
                this.property_occupancy_images = this.property_occupancy_images;
                this.model.property_occupancy_images = this.property_occupancy_images; // sets sthe model.
};          
if (data.attach_file_array_name == 'property_condition_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
    this.property_condition_images.push({
                  file_name: data.full_file_name,
                  job_file: this.set_job_file,
                  subject_file: this.set_subject_file,
                  file_id: data.file_id,
                  file_server_location: data.file_server_location,
                  file_ext: data.file_ext,
                  file_brand_id: data.file_brand_id,
                  file_access_level: data.file_access_level,
                  assigned_to_agents: data.assigned_to_agents,
                  // assigned_to_agents: '[]',
                  brand_type_id: data.brand_type_id
                });
                this.property_condition_images = this.property_condition_images;
                this.model.property_condition_images = this.property_condition_images; // sets sthe model.
};
if (data.attach_file_array_name == 'property_type_images'){
  // console.log('attached_file_array_name: ', data.attach_file_array_name);
   this.property_type_images.push({
                 file_name: data.full_file_name,
                 job_file: this.set_job_file,
                 subject_file: this.set_subject_file,
                 file_id: data.file_id,
                 file_server_location: data.file_server_location,
                 file_ext: data.file_ext,
                 file_brand_id: data.file_brand_id,
                 file_access_level: data.file_access_level,
                 assigned_to_agents: data.assigned_to_agents,
                // assigned_to_agents: '[]',
                 brand_type_id: data.brand_type_id
               });
               this.property_type_images = this.property_type_images;
               this.model.property_type_images = this.property_type_images; // sets sthe model.
          };     


// this.toastr.success('File Attached to Attempt.');
   // this.isShow = !this.isShow; // hides the div again
    // this.isShow_uploaded = !this.isShow_uploaded;

    // closes the model when opened from file browser.
    // this.modalRef.hide();
  // }
}


RemoveElementFromAllRecipients_Parent(key: number) {
  // removes agents
  // this.allEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Report
  // this.allClientEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Invoice
  // this.allClientInvoiceEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientInvoiceEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes Login Users
  // this.allLoginEmailRecipients.forEach((value, index) => {
  //   if (value.user_id === key) {
  //     this.allLoginEmailRecipients.splice(index, 1);
  //   }
  // });

  // removes all attachments
  this.allAttachments.forEach((value, index) => {
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
      this.toastr.success('File Attachment cleared.')
    }
  });
}


RemoveElementFromAllEmailRecipients(key: number) {
  // removes agents
  // this.allEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Report
  // this.allClientEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Invoice
  // this.allClientInvoiceEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientInvoiceEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes Login Users
  // this.allLoginEmailRecipients.forEach((value, index) => {
  //   if (value.user_id === key) {
  //     this.allLoginEmailRecipients.splice(index, 1);
  //   }
  // });

  // removes all attachments
  this.allAttachments.forEach((value, index) => {
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
    }
  });
}


// uses this for attempts removal of files in array
RemoveElementFromAllAttach(key: number, attach_file_array_name) {


    // removes all property_sign_images
    if(attach_file_array_name == 'property_sign_images'){
    this.model.property_sign_images.forEach((value, index) => {
      if (value.file_name === key) {
        this.model.property_sign_images.splice(index, 1);
      }
    });
  }

    // removes all propety_images
    if(attach_file_array_name == 'property_images'){
    this.model.property_images.forEach((value, index) => {
      if (value.file_name === key) {
        this.model.property_images.splice(index, 1);
      }
    });
}


  // removes all attachments - general to the attempt
  this.allAttachments.forEach((value, index) => {
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
    }
  });
}




getSubjectContactNumbers(subject_id) {
  this._demoService.getSubjectContactNumbers(subject_id).subscribe(
     data => { this.subject_contact_numbers = data; },
     err => console.error(err),
      () => {
        console.log('done loading SCN');
                    }
        );
 }



 addSubjectFromModal(sent_model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

let condition_checker = 0;

// Block same subject ID being added - (system automation id is the passed subject_id from the modal function)
if(sent_model.subject_id == this.subject_id){
  condition_checker = 1;
  this.toastr.warning("You cannot add the same subject to for the mulitple entry!");
}

// if(sent_model.subject_id == this.model.subject_id){
//   condition_checker = 1;
//   this.toastr.warning("You cannot add the same subject to for the mulitple entry!");
// }


console.log('Sent Subject : ' + sent_model.subject_id + ' Vs Subject: ' + this.model.subject_id);
console.log('Sent Address: ' + sent_model.street_address + ' Vs Current Address: ' + this.model.address_1);
console.log('Sent Suburb: ' + sent_model.suburb + ' Vs Current: ' + this.model.suburb);
console.log('Sent state: ' + sent_model.state + ' Vs Current: ' + this.model.state);
console.log('Sent Business Name: ' + sent_model.business_name + ' Vs Current: ' + this.model.business_name);
console.log('Sent Subject Name: ' + sent_model.subject_name + ' Vs Current: ' + this.model.subject_name);


console.log('Sent Subject Brnad Reporinng Name: ' + sent_model.brand_report_id + ' Vs Current: ' + this.model.subject_model.brand_report_name);
console.log('Sent Subject Brnad Reporinng User: ' + sent_model.brand_report_user_id + ' Vs Current: ' + this.model.job_model.brand_report_user_id);
console.log('Sent Subject Type: ' + sent_model.job_subject_type_id + ' Vs Current: ' + this.model.subject_model.job_subject_type_id);
console.log('Sent Subject Job Service Rule: ' + sent_model.job_service_rule_id + ' Vs Current: ' + this.model.subject_model.job_service_rule_id);
console.log('Sent Subject Job Service Timefame: ' + sent_model.job_service_timeframe_id + ' Vs Current: ' + this.model.subject_model.job_service_timeframe_id);
console.log('Sent Subject Job Service Type: ' + sent_model.subject_service_type_id + ' Vs Current: ' + this.model.subject_model.subject_service_type_id);


/*
  "job_subject_type_id": "1",

    "job_service_rule_id": "7",
    "job_service_timeframe_id": "34",
    "subject_service_type_id": "1",
*/

// console.log('Sent Agent in Array: ' + sent_model.allocated_to + ' Vs Current: ' + this.model.who_service_name + ' ' + this.model.who_service);

// console.log('Sent Model: ' + JSON.stringify(sent_model))


if(sent_model.street_address != this.model.address_1 || sent_model.suburb != this.model.suburb || sent_model.postcode != this.model.postcode || sent_model.state != this.model.state ){
  condition_checker = 1;
  this.toastr.warning("You cannot add a subject with a different address or location!");
}

// Same Service Rukes.

if(sent_model.brand_report_user_id != this.model.job_model.brand_report_user_id || sent_model.brand_report_id != this.model.subject_model.brand_report_name ){
  condition_checker = 1;
  this.toastr.warning("You cannot add a subject with differing reporting companies and users!");
}

// service rules and timeframes
if(sent_model.job_service_rule_id != this.model.subject_model.job_service_rule_id || sent_model.job_service_timeframe_id != this.model.subject_model.job_service_timeframe_id ||  sent_model.subject_service_type_id != this.model.subject_model.subject_service_type_id ){
  condition_checker = 1;
  this.toastr.warning("You cannot add a subject with differing reporting service rules and timeframes!");
}


if(sent_model.subject_service_type_id != this.model.subject_model.subject_service_type_id ){
  condition_checker = 1;
  this.toastr.warning("You cannot add a subject with differing subject types!");
}


// check if busines name exists in both
// if(sent_model.business_name != null &&  this.model.subject_model.business_name == null ){
//   condition_checker = 1;
//   this.toastr.warning("You cannot add a subject with a business name (commercial), and a subject with a personal name (personal)!");
// }


// // checks for first name exists in both.
// if(sent_model.first_name != null &&  this.model.subject_model.first_name == null ){
//   condition_checker = 1;
//   this.toastr.warning("You cannot add a subject with a missing subject name!. The Inital Subject may be a business, and this may be a personal");
// }


// if(sent_model.street_address == this.model.address_1){
//   condition_checker = 0;
//   this.toastr.success("");
// }

// if(sent_model.suburb != this.model.suburb!){
//   condition_checker = 1;
//   this.toastr.warning("You cannot add a subject with a different address or location, including suburb!");
// }





// if(system_automation_id != this.subject_id){
  if(condition_checker == 0){
      this.allAutomations.push(
        sent_model.subject_id
      );

      this.allAutomations = this.allAutomations;
      // this.model.system_automation_array = this.allAutomtaions;

      // simple small updated - quick and then refresh the page
      // this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
      // this.model.log_type_id = this.log_type_id;

      this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // prbably dont need any of this below.

      // rest the list
      // system_automation_array: this.allAutomations,
      let new_model = {
        subject_array: this.allAutomations
      }
      this.getJobSubjectsArray(new_model);


      // model.allRecipients = this.allRecipients;

      // this.model.system_automation_array.push(
      //   system_automation_id
      // )
      // this.model.system_automation_array = this.allAutomtaions;
      // this.updateSystemLogType(model);
      // this.getSystemLogType(this.log_type_id);

      this.modalRef.hide();
      // console.log('Added External Recipeint.');
      // this.toastr.info('External Recipient Added');

} // end if 

};





 addAutomationFromModal(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

let condition_checker = 0;

// Block same subject ID being added - (system automation id is the passed subject_id from the modal function)
if(system_automation_id == this.subject_id){
  condition_checker = 1;
  this.toastr.warning("You cannot add the same subject to for the mulitple entry!");
}

if(system_automation_id == this.subject_id){
  condition_checker = 1;
  this.toastr.warning("You cannot add the same subject to for the mulitple entry!");
}



if(system_automation_id != this.subject_id){

      this.allAutomations.push(
        system_automation_id
      );

      this.allAutomations = this.allAutomations;
      // this.model.system_automation_array = this.allAutomtaions;

      // simple small updated - quick and then refresh the page
      // this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
      // this.model.log_type_id = this.log_type_id;

      this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // prbably dont need any of this below.

      // rest the list
      // system_automation_array: this.allAutomations,
      let new_model = {
        subject_array: this.allAutomations
      }
      this.getJobSubjectsArray(new_model);


      // model.allRecipients = this.allRecipients;

      // this.model.system_automation_array.push(
      //   system_automation_id
      // )
      // this.model.system_automation_array = this.allAutomtaions;
      // this.updateSystemLogType(model);
      // this.getSystemLogType(this.log_type_id);

      this.modalRef.hide();
      // console.log('Added External Recipeint.');
      // this.toastr.info('External Recipient Added');

} // end if 

};

addAttemptsFromModal(sent_model, subject_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

// Block same subject ID being added - (system automation id is the passed subject_id from the modal function)
// if(sent_model.subject_id == this.subject_id){
//   this.toastr.warning("You cannot add the same subject to for the mulitple entry!");
// }
 

let index = this.allAttempts.findIndex((item) => item.subject_id === sent_model.subject_id);


// Check if the object with the specified property value exists in the array
if (index === -1) {
  // If not found, push a new object with the desired properties
  // arrayObj.push({ name: "bar", text: "sour" });
  this.allAttempts.push({
    ...sent_model
    })

} else {
  // If found, log a message indicating that the object already exists
 // this.toastr.warning( sent_model.subject_id + " Already Exists")
  console.log("Object already exists");

      // do delete and re add
      this.allAttempts.splice(index, 1); // Clears the object and resets the array
      this.allAttempts.push({
        ...sent_model
        })

  this.toastr.info( sent_model.subject_id + " Reset and Updated Data")

   
}







// Original

// if(sent_model.subject_id != this.subject_id){} // end if 
//       this.allAttempts.push(
//         sent_model
//       );

//       this.allAttempts = this.allAttempts;




      // this.model.system_automation_array = this.allAutomtaions;

      // simple small updated - quick and then refresh the page
      // this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
      // this.model.log_type_id = this.log_type_id;

 //     this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // prbably dont need any of this below.

      // rest the list
      // system_automation_array: this.allAutomations,
              // let new_model = {
              //   subject_array: this.allAutomations
              // }
              // this.getJobSubjectsArray(new_model);


      // model.allRecipients = this.allRecipients;

      // this.model.system_automation_array.push(
      //   system_automation_id
      // )
      // this.model.system_automation_array = this.allAutomtaions;
      // this.updateSystemLogType(model);
      // this.getSystemLogType(this.log_type_id);

//    this.modalRef.hide();
      // console.log('Added External Recipeint.');
      // this.toastr.info('External Recipient Added');



};



addAutomationFromFunction(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

// Block same subject ID being added - (system automation id is the passed subject_id from the modal function)
// if(system_automation_id == this.subject_id){
//   this.toastr.warning("You cannot add the same subject to for the mulitple entry!");
// }


// if(system_automation_id != this.subject_id){} // end if 
      this.allAutomations.push(
        system_automation_id
      );

      this.allAutomations = this.allAutomations;
      // this.model.system_automation_array = this.allAutomtaions;

      // simple small updated - quick and then refresh the page
      // this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
      // this.model.log_type_id = this.log_type_id;

      this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // prbably dont need any of this below.

      // rest the list
      // system_automation_array: this.allAutomations,
      let new_model = {
        subject_array: this.allAutomations
      }
      this.getJobSubjectsArray(new_model);


      // model.allRecipients = this.allRecipients;

      // this.model.system_automation_array.push(
      //   system_automation_id
      // )
      // this.model.system_automation_array = this.allAutomtaions;
      // this.updateSystemLogType(model);
      // this.getSystemLogType(this.log_type_id);

      this.modalRef.hide();
      // console.log('Added External Recipeint.');
      // this.toastr.info('External Recipient Added');



};



getJobSubjectsArray(request_array) {
  this._demoService.getJobSubjectsArray(request_array).subscribe(
     data => { this.job_subjects = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;



    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 RemoveElementFromAllAutomations(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAutomations.forEach((value, index) => {
    if (value === key) {
      this.allAutomations.splice(index, 1);
    }
  });

      this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        subject_array: this.allAutomations
      }
      this.getJobSubjectsArray(new_model);

      this.toastr.success("Removed Subject from the event.")

    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



RemoveElementFromAllAttempts(key: number, base_model) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
            // this.allAttempts.forEach((value, index) => {
            //   if (value === key) {
            //     this.allAttempts.splice(index, 1);
            //   }
            // });

      // this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      // let new_model = {
      //   subject_array: this.allAutomations
      // }
      // this.getJobSubjectsArray(new_model);






  // Need to add a filter if already exists
   // @:: https://stackoverflow.com/questions/1988349/array-push-if-does-not-exist
// Find the index of an object with a specific property value
let index = this.allAttempts.findIndex((item) => item.subject_number === base_model.subject_number);

// Check if the object with the specified property value exists in the array
if (index === -1) {
  // If not found, push a new object with the desired properties
  // arrayObj.push({ name: "bar", text: "sour" });
  // this.allAttempts.push({
  //   ...base_model
  //   })
//  this.toastr.warning( base_model.subject_id + " Does Not Exists")

} else {
  
  let count_allAttempts = this.allAttempts.length;
  
  // If found, log a message indicating that the object already exists
  // delete this.allAttempts[index]; // simple delete with the index - leaves the object as undefined. // does not reset indexes etc... dont use.
  // @::https://sentry.io/answers/remove-specific-item-from-array/
  this.allAttempts.splice(index, 1); // Clears the object and resets the array

  this.toastr.success( base_model.subject_number + " Removed from Multiple Attempts: " + index)
  // console.log("Object already exists");
  // Ceans the array and object if its the last
          // if(count_allAttempts <= 1){
          //   this.allAttempts = [];
          // }

          // this.allAttempts = this.allAttempts;

}














      this.toastr.success("Removed Subject from the multiple attempt.")

    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};




// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};




 // drop down function
 onChangeVariables(args): void {
 
  console.log(args.itemData);
 
  // alert("Testing System, " + args.value);
let data = JSON.stringify(args.itemData);
console.log("Data " + data);


let json_data = JSON.parse(data);
console.log('json_data ' + json_data.Offset)
console.log('json_data ' + json_data.Id)

  this.form.controls['service_local_timezone'].patchValue(json_data.Offset); // works by setting the new frorm value from parent modal.



  // this.form.controls['service_local_timezone'].patchValue(args.itemData); // works by setting the new frorm value from parent modal.
  // this.toastr.info("Args Value: " + args.itemData["offset"]);

  // console.log(args);


  this.model.service_local = args.value;
  this.form.controls['service_local'].patchValue(args.value); // works by setting the new frorm value from parent modal.

 
  //  let element: HTMLElement = document.createElement('p');
  if (args.isInteracted) {
    //  element.innerText = 'Changes happened by Interaction';
   //  this.container.documentEditor.editor.insertText(args.value);
   //  this.toastr.info('Variable Added at cursor position within document');
    // hide the modal
    // this.modalRef.hide();


// prbably dont need any of this below.

// consider all these
/**/
    // DataUtil.serverTimezoneOffset = new Date().getTimezoneOffset()/60; 
    // this.local_date_time = new Date(new Date().getTime());
    // var offset = new Date().getTimezoneOffset();
    // this.local_date_time_offset = offset;
    // this.local_date_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone

    // What if we just set ast the"coutnry/city" instead and see if that works.
    // this.service_local_timezone = args.value; // this sets the current clients user timezone for the database.
    // this.model.service_local_timezone = args.value;




    // this.service_local_offset = new Date().getTimezoneOffset(); // this sets the current clients user timezone for the database.
    // this.service_local = Intl.DateTimeFormat().resolvedOptions().timeZone



    
  } else {
    // element.innerText = 'Changes happened by programmatic';
  }

  // document.getElementById('event').append(element);
};



onTimeChange(model){

// this.toastr.info('changes cumin')

      // need to set the txt....??
      const dateTime = new Date(model.time_service).toLocaleTimeString('en-AU', {
        hour: 'numeric', minute: 'numeric', hour12: true
        });
  
  
      // this.model.time_service_text = this.mytime;
      this.model.time_service_text = dateTime;
      model.time_service_text = dateTime;
};




LoadSubjectserviceOutcomeTemplateParagraph(model){
  this.show_paragraph = 0;


  // console.log(JSON.stringify(model));
let dataUtil = DataUtil.parse.parseJson(model);


  
let model2 = model;
/*
 "subject_attempt_type_id": "2",
  "subject_service_outcome_id": "14",
  "attempts": "Attempts are continuing."
*/
console.log('model.attempts: ' + dataUtil.attempts)
console.log('model.subject_attempt_type_id: ' + model2.subject_attempt_type_id )
// model2 = model2
// Outcome 1  Attempt, subject Did not appear, attempts, contunueing.
  if(
    // && model2.attempts == "Attempts are continuing."
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14'
    ){
      this.load_ssot_id = 1 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      console.log('Outcome 1');
      this.show_paragraph = 1

    } // determine which template to load
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14' && model2.attempts == "Our agent will now close their file."
      ){
        // this.load_ssot_id = 2 
        // this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // console.log('Outcome 2');
        // this.show_paragraph = 1
      } // determine which template to load

// TRIGGERS AND SWITCHES - Real & Live



// BOF Subject Service.
// Service :: 1 - Personal
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '1' && model2.who_service >= 1
  ){
    this.load_ssot_id = 1 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 1 - Personal");
      console.log('Service :: 1 - Personal');
      this.show_paragraph = 1
  }
  // Service :: 2 - Personal Service: In thier capacity as Director
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '6' && model2.who_service >= 1
  ){
    this.load_ssot_id = 5 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 2 - Personal Service: In thier capacity as Director");
      this.show_paragraph = 1
  }

    // Service :: 3 - Personal Service: Personal Service to Witness
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '7' && model2.who_service >= 1 && model2.witness_name != null
  ){
    this.load_ssot_id = 6 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 3 - Personal Service: Personal Service to Witness");
      this.show_paragraph = 1
  }
      // Service :: 4 - Personal Service: Non-Personal to fellow occupant
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '2' && model2.who_service >= 1 && model2.fellow_occupants_name != null
  ){
    this.load_ssot_id = 7 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 4 - Personal Service: Non-Personal to fellow occupant");
      this.show_paragraph = 1
  }
// Service :: 5 - Personal Service: Non-Personal to an authorised employee
    if(
      model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '3' && model2.who_service >= 1 && model2.authorised_employee_name != null
      ){
        this.load_ssot_id = 8 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Service :: 5 - Personal Service: Non-Personal to an authorised employee");
          this.show_paragraph = 1
      }

// Service :: 6 - Personal Service: Non-Personal by affixing to the front door
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '8' && model2.who_service >= 1
  ){
    this.load_ssot_id = 9 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }      


  // Service ::id22 - Individual Service (Residential): Placing under the Front Door 
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '22' && model2.who_service >= 1
  ){
    this.load_ssot_id = 47 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }      

// ::id23  Individual Service (Residential): Affixing to the Front Gate or Fence
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '23' && model2.who_service >= 1
  ){
    this.load_ssot_id = 48 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  


  // ::id24 Individual Service (Residential): Affixing at Vacant Land
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '24' && model2.who_service >= 1
  ){
    this.load_ssot_id = 49 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  


    // ::id25 Individual Service: Leaving in their Presence
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '25' && model2.who_service >= 1
  ){
    this.load_ssot_id = 50 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  



      // ::id26 Individual Service: Keeping House NSW only (UCPR Rule 10.26)
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '26' && model2.who_service >= 1
  ){
    this.load_ssot_id = 51 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  


        // ::id27 Individual (Hand Delivery of Letter or NTV): Personal
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '27' && model2.who_service >= 1
  ){
    this.load_ssot_id = 52 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  
  // ::id28 Individual or Company: Delivery of Letter or NTV: Affixing to the Front Door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '28' && model2.who_service >= 1
    ){
      this.load_ssot_id = 53 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  

  // ::id29 Individual or Company: Delivery of Letter or NTV: Leaving in the Letterbox
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '29' && model2.who_service >= 1
    ){
      this.load_ssot_id = 54 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  

  // ::id30 Individual or Company: Delivery of Letter or NTV: Placing under the Front Door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '30' && model2.who_service >= 1
    ){
      this.load_ssot_id = 55 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  
  // ::id31 Individual or Company: Delivery of Letter or NTV: Placing under the Front Door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '31' && model2.who_service >= 1
    ){
      this.load_ssot_id = 56 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  

  // ::id32 Trust: Personal Service on Trustee
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '32' && model2.who_service >= 1
    ){
      this.load_ssot_id = 57 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  


     
  // WAS missing.
// Service :: 6+++ - Personal Service: Non-Personal by leaving in the letterbox
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '9' && model2.who_service >= 1
  ){
    this.load_ssot_id = 42 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }      
     


// Service :: 7 - Business of Partnership - Non Personal - Person in Charge
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '20' && model2.who_service >= 1
  ){
    this.load_ssot_id = 10 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 7 - Business of Partnership - Non Personal - Person in Charge");
      this.show_paragraph = 1
  }    
// Service :: 8 - Non Personal - By Post
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '13' && model2.who_service >= 1
  ){
    this.load_ssot_id = 11 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 8 - Non Personal - By Post");
      this.show_paragraph = 1
  }
// Service :: 9 - Non Personal - By Email
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '14' && model2.who_service >= 1
  ){
    this.load_ssot_id = 12 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 9 - Non Personal - By Email");
      this.show_paragraph = 1
  }          
// Service :: 10 - Non Personal - to Authorised Legal Representative QLD
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '10' && model2.who_service >= 1
  ){
    this.load_ssot_id = 13 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 10 - Non Personal - to Authorised Legal Representative QLD");
      this.show_paragraph = 1
  }          
// Service :: 11 - Non Personal - to Authorised Legal Representative Non-QLD
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '11' && model2.who_service >= 1
  ){
    this.load_ssot_id = 14 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 11 - Non Personal - to Authorised Legal Representative Non-QLD");
      this.show_paragraph = 1
  }  
// Service :: 12 - Non Personal - Service on Prisoner to Person in charge of Prison
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '12' && model2.who_service >= 1
  ){
    this.load_ssot_id = 15 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 12 - Non Personal - Service on Prisoner to Person in charge of Prison");
      this.show_paragraph = 1
  }  
// Service :: 13 - By affixing to a building or leaving in a letterbox
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '5' && model2.who_service >= 1
  ){
    this.load_ssot_id = 16 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 13 - By affixing to a building or leaving in a letterbox");
      this.show_paragraph = 1
  }  
// Service :: 14 - To the Registered Office
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '4' && model2.who_service >= 1
  ){
    this.load_ssot_id = 17 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 14 - To the Registered Office");
      this.show_paragraph = 1
  }  

// Skipped a few as they do not exist in the system.

// Service :: 18 - Company - Registered Office - Authorised Employee
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '15' && model2.who_service >= 1
  ){
    this.load_ssot_id = 18 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 18 - Company - Registered Office - Authorised Employee");
      this.show_paragraph = 1
  }  

// Service :: 19 - Company - Registered Office - By Affixing to the address
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '16' && model2.who_service >= 1
  ){
    this.load_ssot_id = 19 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 19 - Company - Registered Office - By Affixing to the address");
      this.show_paragraph = 1
  }  


// Service :: 21 - Company - Registered Office - By sliding under the door
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '17' && model2.who_service >= 1
  ){
    this.load_ssot_id = 20 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 21 - Company - Registered Office - By sliding under the door");
      this.show_paragraph = 1
  }  

// Service :: 22 - Company - Registered Office - By leaving in the letterbox
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '18' && model2.who_service >= 1
  ){
    this.load_ssot_id = 21 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 22 - Company - Registered Office - By leaving in the letterbox");
      this.show_paragraph = 1
  }  


// Service :: 23 - Company - Registered Office - Personal Service on Director
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '19' && model2.who_service >= 1
  ){
    this.load_ssot_id = 22 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 23 - Company - Registered Office - Personal Service on Director");
      this.show_paragraph = 1
  }  

// Service :: 24 - Service Under Order
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '21' && model2.who_service >= 1
  ){
    this.load_ssot_id = 23 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 24 - Service Under Order");
      this.show_paragraph = 1
  }  




// BOF: SUBJECT Attendance

// Attendance :: 25 - Documents Not Served - Person spoken With at the address
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '8' && model2.subject_location_status_id === '2' && model2.who_service >= 1
  ){
    this.load_ssot_id = 24 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 25 - Documents Not Served - Person spoken With at the address");
      this.show_paragraph = 1
  }  


// Attendance :: 26 - Documents Not Served - no one home at the address
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '8' && model2.subject_location_status_id === '1' && model2.who_service >= 1
  ){
    this.load_ssot_id = 25 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 26 - Documents Not Served - no one home at the address");
      this.show_paragraph = 1
  }  

// Attendance :: 27 - Subject not Located at address - Person spoken With at the address
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '10' && model2.subject_location_status_id === '2' && model2.who_service >= 1
  ){
    this.load_ssot_id = 26 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 27 - Subject not Located at address - Person spoken With at the address");
      this.show_paragraph = 1
  }  

  // Attendance :: 28 - Subject not Located at address - no one home at the address
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '10' && model2.subject_location_status_id === '1' && model2.who_service >= 1
  ){
    this.load_ssot_id = 27 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 28 - Subject not Located at address - no one home at the address");
      this.show_paragraph = 1
  }  

// Attendance :: 29 - Field Call - Person spoken With at the address
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '24' && model2.subject_location_status_id === '2' && model2.who_service >= 1
  ){
    this.load_ssot_id = 28 // This must be unique for each paragraph output... hard coded to match data records. 
    // this.load_ssot_id = 28 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 29 - Field Call - Person spoken With at the address");
      this.show_paragraph = 1
  }  


// Attendance :: 30 - Field Call - no one home at the address
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '24' && model2.subject_location_status_id === '1' && model2.who_service >= 1
  ){
    // this.load_ssot_id = 29 // This must be unique for each paragraph output... hard coded to match data records. 
    this.load_ssot_id = 29 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 30 - Field Call - no one home at the address");
      this.show_paragraph = 1
  }  




  // // Attendance :: 33 - Field Call Attendance -- NEW GENERAL ATTENDANCE STAFF Nov 2033
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '25'  && model2.who_service >= 1 
  ){
    this.load_ssot_id = 30 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 33 - Field Call Attendance");
      this.show_paragraph = 1
  }  

    // october commented out as it not required as two above cover this.
// // Attendance :: 33 - Field Call Attendance
// if(
//   model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '24'  && model2.who_service >= 1 
//   ){
//     this.load_ssot_id = 30 // This must be unique for each paragraph output... hard coded to match data records. 
//       this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
//       // this.toastr.info("Attendance :: 33 - Field Call Attendance");
//       this.show_paragraph = 1
//   }  

// Attendance :: 34 - Occupancy Check Attendance
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '11'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 31 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 34 - Occupancy Check Attendance");
      this.show_paragraph = 1
  }  


// Attendance :: 35 - Drive-by Inspection Report
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '12'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 32 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 35 - Drive-by Inspection Report");
      this.show_paragraph = 1
  }  


// Attendance :: 36 - Appeared
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '13'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 33 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 36 - Appeared");
      this.show_paragraph = 1
  }  

// Attendance :: 37 - Did Not Appear
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 34 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 37 - Did Not Appear");
      this.show_paragraph = 1
  }  

// Attendance :: 38 - Document Filing
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '15'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 35 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 38 - Document Filing");
      this.show_paragraph = 1
  }  

// Attendance :: 39 - Lockout Report
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '16'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 36 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 39 - Lockout Report");
      this.show_paragraph = 1
  }  

  // Attendance :: 40 - Phone Call Made
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '17'  && model2.who_service >= 1
  ){
    this.load_ssot_id = 37 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 40 - Phone Call Made");
      this.show_paragraph = 1
  }  


  // Attendance :: 41 - Phone Call Received
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '18'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 38 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 41 - Phone Call Received");
        this.show_paragraph = 1
    }  
  
  
  // Attendance :: 42 - Email Sent
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '19'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 39 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 42 - Email Sent");
        this.show_paragraph = 1
    }  
  
    
  // Attendance :: 43 - Email Received
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '20'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 40 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 43 - Email Received");
        this.show_paragraph = 1
    }  
  
    // Attendance :: 44 - The Subject was interviewed at the address
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '9'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 41 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  
    
    
      // Missing skip Traces in the code?
      
  
  
    // Attendance :: 45 - Skip Trace - Located
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '21'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 43 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  


    // Attendance :: 46 - Skip Trace - Possible Locate
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '22'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 44 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  


    // Attendance :: 47 - Skip Trace - Not Located
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '23'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 45 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  

      // id36 the address could not be located
      if(
        model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '26'  && model2.who_service >= 1
        ){
          this.load_ssot_id = 58 // This must be unique for each paragraph output... hard coded to match data records. 
            this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
            // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
            this.show_paragraph = 1
            
        }  
  


    // id27 Occupancy Check: (Complete the Text Box Field Below)
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '27' && model2.subject_location_status_id === '2' && model2.who_service >= 1
      ){
        this.load_ssot_id = 59 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 29 - Field Call - Person spoken With at the address");
          this.show_paragraph = 1
      }  
    
    
    //  Occupancy Check: (Complete the Text Box Field Below)
    // Attendance :: 30 - Field Call - no one home at the address
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '27' && model2.subject_location_status_id === '1' && model2.who_service >= 1
      ){
        this.load_ssot_id = 60 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 30 - Field Call - no one home at the address");
          this.show_paragraph = 1
      }  
    
    //  id28 text sent
      if(
        model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '28'  && model2.who_service >= 1
        ){
          this.load_ssot_id = 61 // This must be unique for each paragraph output... hard coded to match data records. 
            this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
            // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
            this.show_paragraph = 1
            
        }  
  

    //  id29 text recieved
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '29'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 62 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  



      // Subject service Affixed to -- any attempts (outcomes)
      // && model2.attempts == "".

// Older methods written into the system above.
      // if(
          //   model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '5'
          //   ){
          //     this.load_ssot_id = 4 
          //     this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          //     console.log('Outcome 2');
          //     this.show_paragraph = 1
          //   } // determine which template to load


    // this.getSubjectServiceOutcomeTemplate(1, model);
    
  let load_ssot_id = 1

}


// PHP script ot render paragraph
private getSubjectServiceOutcomeTemplateRendered(ssot_id, model) {


}

private getSubjectServiceOutcomeTemplate(ssot_id, model) {


  // Variable Name Functions FIST
 // Run Some Functinos to get the real Values not IDS. MUST RUN THESE FIRST TO LOAD CONTENT NBELOW


 // LOOKUPS FIRST....

 // Must have if statements otherwise breaks the merge variables conversions
 if(model.subject_attempt_type_id != ''){
 this.getSubjectAttemptType_Q(model.subject_attempt_type_id);
 }
 if(model.subject_attempt_type_id != ''){
  this.getBrand_Q(model.who_service);
 }
 // Job report client changed... to
// if(this.job_model.brand_report_id != ''){
//   this.getBrand_report_Q(this.job_model.brand_report_id);
//  }
 if(model.brand_report_id != ''){
  // this.getBrand_report_Q(this.job_model.brand_report_id);
  // I changed this brand was brand_report_id
  // this.getBrand_report_Q(this.job_model.brand_report_id);

  // this.getBrand_report_Q(this.model.brand_report_id );
  this.getBrand_report_Q(model.brand_report_id );
  

 }


 // can only activate particular functions if the content exiss otherwise crashes the entire system
  if(model.subject_service_type_id){
 this.getSubjectServiceType_Q(model.subject_service_type_id);
  }
  
  
// october 2023 was missing
if(model.property_type_id){
  this.getPropertyType(model.property_type_id) 
}

  if(model.subject_service_method_id){
 this.getServiceMethod_Q(model.subject_service_method_id) ;
  }


  if(this.subject_model.job_subject_type_id){
    this.getJobSubjectType_Q(this.subject_model.job_subject_type_id) ;
     }
   

  if(model.fellow_occupants_relationship){
//$templateProcessor->setValue($f_starter . 'subject_relationship_name' ,  $json_serviceR[0]->subject_relationship_name);
this.getSubjectRelationship_Q(model.fellow_occupants_relationship)
// /fellow_occupants_relationship

  }else{
    // this.subject_service_fellow_relationship.subject_relationship_name == null;
  }


if(model.subject_service_outcome_id){
this.getSubjectServiceOutcome_Q(model.subject_service_outcome_id) ;
  }


if(model.exact_service_method_id ){
this.getSubjectExactServiceMethod_Q(model.exact_service_method_id) ;
}

// // subject service october for method to show name if note an ID.
if( model.exact_service_method){
  // may need to lookup differently
  this.getSubjectExactServiceMethod_Q(model.exact_service_method) ;
  }

if(model.subject_location_status_id){
this.getSubjectLocationStatus_Q(model.subject_location_status_id) ;
  }   

  if(model.subject_location_status_found_id){
    this.getSubjectLocationStatusFound_Q(model.subject_location_status_found_id) ;
      }   
  


// clear everything
model.service_paragraph = '';
// this.attemptForm.controls['service_paragraph'].patchValue('');
model.service_paragraph_rendered = '';
// this.attemptForm.controls['service_paragraph_rendered'].patchValue('');

  this._demoService.getSubjectServiceOutcomeTemplate(ssot_id)
    .subscribe(
      res => {
        this.subject_service_outome_template = res;
        let data = res[0]


   // Just hide all this section as not required.     
      model.service_paragraph = data.ssot_template_HTML;
      this.attemptForm.controls['service_paragraph'].patchValue(data.ssot_template_HTML);

      // October  2023 :: Add template ssot_id to attempt so triggers and automations can run conditions.
      model.ssot_id = data.ssot_id;
      this.attemptForm.controls['ssot_id'].patchValue(data.ssot_id);

      

  this.getSubjectServiceOutcomeTemplate_ResolutionOutcomes(data.ssot_id)

          // // Meger Variables one by one - this works but only one at a time
          //   var str = data.ssot_template_HTML;
          //   var newstr = str.replace('${f_subject_name}', "oranges",); 
          //   // newstr = str.replace('${job_instructions_month}', "January"); 
            
          //   this.model.service_paragraph_rendered = newstr;
          //   this.attemptForm.controls['service_paragraph_rendered'].patchValue(newstr);


                // // merge variables using a mapped object
                // // @:https://stackoverflow.com/questions/15604140/replace-multiple-strings-with-multiple-other-strings

                // var str = data.ssot_template_HTML;
                // var mapObj = {
                // "${f_subject_name}":"dog",
                // "${job_instructions_month}":"January",

                // };
                // // var mapObj = {
                // //   "${f_subject_name}":"dog",
                // //   dog:"goat",
                // //   goat:"cat"
                // //   };
                // // str = str.replace(/cat|dog|goat/gi, function(matched){
                // // return mapObj[matched];
                // // });



                // var re = new RegExp(Object.keys(mapObj).join("|"),"gi");
                // str = str.replace(re, function(matched){
                //   return mapObj[matched];
                // });
                // this.model.service_paragraph_rendered = re;
                // this.attemptForm.controls['service_paragraph_rendered'].patchValue(re);







   


        // chosen Render/Merge Version local on page in javascript.  Rendered Pior to save.       
                // Had to change tsconfig.json to make this work
                // ::@https://www.geeksforgeeks.org/javascript-replace-multiple-strings-with-multiple-other-strings/
                // https://stackoverflow.com/questions/63616486/property-replaceall-does-not-exist-on-type-string
                /*
                    "lib": [
                    ...,
                    "ES2021.String"
                    ]
                */

                    // This method we can l chosen to replace all variables for SubjectServiceOutcomeTemplate Merging - August 2023
                    // Add missing Logic here theat I apply in merge.php to return dates, names and other fields currently undefined.

// UPPER CASE CONVERSIONS FRIST
//  const job_registry_name = this.job_model.registry_name;
//  const job_registry_name_UPPER = job_registry_name.toUpperCase() 
// let subject_attempt_type_name =  this.subject_attempt_type.subject_attempt_type_name
// const subject_attempt_type_name_UPPER = job_registry_name.toUpperCase() 




// All if statements and check MUST run before ".replaceAll()"
// Subject Name CHeck


// Establish the Variables

/*
// Current Subject Variables.
.replaceAll('${subject_id}', this.subject_model.subject_id)
.replaceAll('${subject_number}', this.subject_model.subject_number)
.replaceAll('${subject_job_status}', this.subject_model.job_status)


// WHAT IF A BUSINESS NAME: RUNS ONCE REMEMBER OR DO I LOOP OVER TWO OR THREE TIMES TO ENSURE WE ARE MERGED?
.replaceAll('${subject_name}', this.subject_model.first_name + ' ' + this.subject_model.middle_name + ' ' + this.subject_model.surname)
.replaceAll('${subject_name_4_doc}', this.subject_model.first_name + '-' + this.subject_model.surname)
.replaceAll('${subject_business_name}', this.subject_model.business_name)
/*




// Start Setup Variables

/*Setp All Subject Varaibales as var_ objects - Variables that need if statemebts, all have to be Run and established prioler to .replaceAll!!!!!! August 2023 */
let var_subject_id = this.subject_model.subject_id;
let var_subject_number =  this.subject_model.subject_number;
let var_subject_job_status =  this.subject_model.job_status;

// Do checks for subject name / Businesss Name of FUll SUbject Name fields
let var_subject_name =  this.subject_model.first_name + ' ' +  this.subject_model.middle_name + ' '+  this.subject_model.surname;
let var_subject_name_4_doc = this.subject_model.first_name +'-'+  this.subject_model.surname;
let var_subject_business_name =  this.subject_model.business_name;

// Subject Name of Business
    if(var_subject_business_name != null && var_subject_business_name != "" ){
        let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
        // $subject_name = $trim_subject_business_name;
         var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
          var_subject_name_4_doc = var_trim_subject_business_name;
        
    }

// Uppercese
let var_job_registry_name = this.job_model.registry_name;
if(var_job_registry_name != null){
let var_job_registry_name_Upper = var_job_registry_name.toUpperCase();
}


// Current Attempt Variables Setups
// Uppercase.

if(this.subject_attempt_type != undefined){
    let var_subject_attempt_type_name = this.subject_attempt_type.subject_attempt_type_name
    this.var_subject_attempt_type_name = var_subject_attempt_type_name;
    if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
    this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
    }
}
// service Methods.
// let var_service_method_name = this.subject_service_method.service_method_name;
if(this.subject_service_method != undefined){ // uppercase must be validated if not null // correct way is to check if the returned qiery is defined.
this.var_service_method_name = this.subject_service_method.service_method_name;
}
// .replaceAll('${f_service_method_name}', this.subject_service_method.service_method_name ) // breaks if not exists


// SAV -- subject relationship (checks if there is content and set the relationship or be null.)
if(this.subject_service_fellow_relationship != null){
  this.subject_service_fellow_relationship  = this.subject_service_fellow_relationship.subject_relationship_name; 
}

// Variables 
let var_subject_service_fellow_relationship =  this.subject_service_fellow_relationship;

if(this.subjectServiceOutcome != undefined){
this.var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name;
}
// let var_service_outcome_name;

// let var_location_status_name;


if(this.subjectLocationStatus != undefined){
this.var_location_status_name = this.subjectLocationStatus.location_status_name;
}


if(this.subjectAttemptPropertyType != undefined){
  this.var_property_type_name = this.subjectAttemptPropertyType.property_type_name
}


// let var_location_status_found_name;
if(this.subjectLocationStatusFound != undefined){
this.var_location_status_found_name = this.subjectLocationStatusFound.location_status_found_name;
}

if(this.subjectExactServiceMethod != undefined){
// .replaceAll('${exact_service_method_name}', this.subjectExactServiceMethod.service_method_name
// this.var_exact_service_method_name = this.subjectExactServiceMethod.service_method_name
this.var_exact_service_method_name = this.subjectExactServiceMethod.exact_service_method_name


}


let var_subject_type_name;
if(this.subject_job_subject_type != null){
var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
} else{
var_subject_type_name = '';
}




// from save script above.

// Commented out as was changing dates and timesones when editing when rendering the input for an attempt
              // // August 2023 - TimeZone Fixed Text
              //   // set a fixed time

                          // commented out for testing to for new time as text only.
                          // const dateTime = new Date(model.time_service).toLocaleTimeString('en-AU', {
                          //   hour: 'numeric', minute: 'numeric', hour12: true
                          //   });


                          // // this.model.time_service_text = this.mytime;
                          // this.model.time_service_text = dateTime;
                          // model.time_service_text = dateTime;


// NEED TO ADD NEW TIMEZONE HERE AS
// Modified October 2023 to fix new entry for time & dates
                        if(model.time_service_text != ''){
                          // set the time_service to to the new time.
                          this.var_time_service = model.time_service_text;
                        }else{
                          this.var_time_service = model.time_service;
                        }





        // // first check if exists to prevent load errors
        // if(model.subject_service_outcome_id){
        //  var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name;
        // }

        // if(model.subject_location_status_id){
        //  var_location_status_name = this.subjectLocationStatus.location_status_name;
        //  }


        //  if(model.subject_location_status_found_id){
        //   var_location_status_found_name = this.subjectLocationStatusFound.location_status_found_name;
        //  }
        

// Start Replace All (Starts to replace everyting below.. One continuus proceedure.)


// Run this before Replace all strins
function runReplaceSubjectName(string){
  const search = ' ';
  const replace = '-';
  const result = string.replace(search, replace);
  return result;
  }



 


// TIP:: SIMPLY CHANGE THE VARAIBLES IF YOU REQUIRE HTML RENDERED FORMATTING etc... to align with interface in SO/Service Card.
// As Plain Text
// Sets the string to be replaced.
// const str2 = data.ssot_template_WORD;
const str2 = data.ssot_template_HTML; // change3 me for frull HTNL variables


// Fallback in case I have not created plain TExt.
// Sets the string to be replaced.
if(data.ssot_template_WORD == null){
const str2 = data.ssot_template_HTML;
}



// New test to run function below to convert the variable

// need all the variables to be loaded first for this to work correctly

// let str3 = runMergeVariables(data.ssot_template_HTML)

// new function to run over any string and retrn string with merged variables initiated.

function runMergeVariables(str2){



const rendered_result = str2        
          // Start of officual Job Vars
          .replaceAll('${job_id}', this.job_model.job_id)
          .replaceAll('${job_number}', this.job_model.job_number)
          .replaceAll('${job_status_code}', this.job_model.job_status_code)
          .replaceAll('${owner_trace_code}', this.job_model.owner_trace_code)
          .replaceAll('${client_ref}', this.job_model.owner_trace_code)
          .replaceAll('${client_reference}', this.job_model.owner_trace_code)
          .replaceAll('${job_document_number}', this.job_model.document_number)
          .replaceAll('${job_registry_name}', this.job_model.registry_name)
          // .replaceAll('${job_registry_name_upper}', job_registry_name_UPPER) // set variables before replaceAll Function

          .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_model.hearing_date, 'M/D/YYYY'))
          .replaceAll('${hearing_date_full_words_time_first}', this.legalDate.format(this.job_model.hearing_date, 'h:mma dddd MMMM Do, YYYY') ) // equivilent to in PHP :: date("g:ia l jS F Y", strtotime($job_hearing_date))
          .replaceAll('${hearing_date_full_words}', this.legalDate.format(this.job_model.hearing_date, 'dddd MMMM Do, YYYY h:mma') )
          .replaceAll('${hearing_date}', this.legalDate.format(this.job_model.hearing_date, 'M/D/YYYY'))
          .replaceAll('${hearing_day}', this.legalDate.format(this.job_model.hearing_date, 'dddd'))
          .replaceAll('${hearing_day_number}', this.legalDate.format(this.job_model.hearing_date, 'Do'))
          .replaceAll('${hearing_month}', this.legalDate.format(this.job_model.hearing_date, 'MMMM'))
          .replaceAll('${hearing_month_number}', this.legalDate.format(this.job_model.hearing_date, 'Mo'))
          .replaceAll('${hearing_month_number_simple}', this.legalDate.format(this.job_model.hearing_date, 'M'))
          .replaceAll('${hearing_year}', this.legalDate.format(this.job_model.hearing_date, 'YYYY'))
          .replaceAll('${hearing_time}', this.legalDate.format(this.job_model.hearing_date, 'h:mma'))

          .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_model.judgement_date, 'M/D/YYYY'))
          .replaceAll('${judgement_date_full_words_time_first}', this.legalDate.format(this.job_model.judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${judgement_date_full_words}', this.legalDate.format(this.job_model.judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${judgement_date}', this.legalDate.format(this.job_model.judgement_date, 'M/D/YYYY'))
          .replaceAll('${judgement_day}', this.legalDate.format(this.job_model.judgement_date, 'dddd'))
          .replaceAll('${judgement_day_number}', this.legalDate.format(this.job_model.judgement_date, 'Do'))
          .replaceAll('${judgement_month}', this.legalDate.format(this.job_model.judgement_date, 'MMMM'))
          .replaceAll('${judgement_month_number}', this.legalDate.format(this.job_model.judgement_date, 'Mo'))
          .replaceAll('${judgement_month_number_simple}', this.legalDate.format(this.job_model.judgement_date, 'M'))
          .replaceAll('${judgement_year}', this.legalDate.format(this.job_model.judgement_date, 'YYYY'))
          .replaceAll('${judgement_time}', this.legalDate.format(this.job_model.judgement_date, 'h:mma'))

          .replaceAll('${job_filing_date}', this.legalDate.format(this.job_model.filing_date, 'M/D/YYYY'))
          .replaceAll('${filing_date_full_words_time_first}', this.legalDate.format(this.job_model.filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${filing_date_full_words}', this.legalDate.format(this.job_model.filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${filing_date}', this.legalDate.format(this.job_model.filing_date, 'M/D/YYYY'))
          .replaceAll('${filing_day}', this.legalDate.format(this.job_model.filing_date, 'dddd'))
          .replaceAll('${filing_day_number}', this.legalDate.format(this.job_model.filing_date, 'Do'))
          .replaceAll('${filing_month}', this.legalDate.format(this.job_model.filing_date, 'MMMM'))
          .replaceAll('${filing_month_number}', this.legalDate.format(this.job_model.filing_date, 'Mo'))
          .replaceAll('${filing_month_number_simple}', this.legalDate.format(this.job_model.filing_date, 'M'))
          .replaceAll('${filing_year}', this.legalDate.format(this.job_model.filing_date, 'YYYY'))
          .replaceAll('${filing_time}', this.legalDate.format(this.job_model.filing_date, 'h:mma'))


          .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_model.instructions_date, 'M/D/YYYY'))
          .replaceAll('${instructions_date_full_words_time_first}', this.legalDate.format(this.job_model.instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${instructions_date_full_words}', this.legalDate.format(this.job_model.instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${instructions_date}', this.legalDate.format(this.job_model.instructions_date, 'M/D/YYYY'))
          .replaceAll('${instructions_day}', this.legalDate.format(this.job_model.instructions_date, 'dddd'))
          .replaceAll('${instructions_day_number}', this.legalDate.format(this.job_model.instructions_date, 'Do'))
          .replaceAll('${instructions_month}', this.legalDate.format(this.job_model.instructions_date, 'MMMM'))
          .replaceAll('${instructions_month_number}', this.legalDate.format(this.job_model.instructions_date, 'Mo'))
          .replaceAll('${instructions_month_number_simple}', this.legalDate.format(this.job_model.instructions_date, 'M'))
          .replaceAll('${instructions_year}', this.legalDate.format(this.job_model.instructions_date, 'YYYY'))
          .replaceAll('${instructions_time}', this.legalDate.format(this.job_model.instructions_date, 'h:mma'))

          .replaceAll('${job_aos_date}', this.legalDate.format(this.job_model.aos_date, 'M/D/YYYY'))
          .replaceAll('${aos_date_full_words_time_first}', this.legalDate.format(this.job_model.aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${aos_date_full_words}', this.legalDate.format(this.job_model.aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${aos_date}', this.legalDate.format(this.job_model.aos_date, 'M/D/YYYY'))
          .replaceAll('${aos_day}', this.legalDate.format(this.job_model.aos_date, 'dddd'))
          .replaceAll('${aos_day_number}', this.legalDate.format(this.job_model.aos_date, 'Do'))
          .replaceAll('${aos_month}', this.legalDate.format(this.job_model.aos_date, 'MMMM'))
          .replaceAll('${aos_month_number}', this.legalDate.format(this.job_model.aos_date, 'Mo'))
          .replaceAll('${aos_month_number_simple}', this.legalDate.format(this.job_model.aos_date, 'M'))
          .replaceAll('${aos_year}', this.legalDate.format(this.job_model.aos_date, 'YYYY'))
          .replaceAll('${aos_time}', this.legalDate.format(this.job_model.aos_date, 'h:mma'))

          // Current Attempt Variables
          .replaceAll('${f_attempt_type_id}', model.subject_attempt_type_id)

          .replaceAll('${f_attempt_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
          .replaceAll('${f_attempt_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

          .replaceAll('${f_attempt_subject_type_id}', model.subject_attempt_type_id)
          .replaceAll('${f_attempt_subject_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
          .replaceAll('${f_attempt_subject_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

          .replaceAll('${f_service_method_id}', model.subject_service_method_id)
          .replaceAll('${f_service_method_name}', this.var_service_method_name ) // tested above.

          .replaceAll('${f_attempt_service_method_id}', model.subject_service_method_id)
          .replaceAll('${f_attempt_service_method_name}', this.var_service_method_name ) // tested above.

          // SAV
          .replaceAll('${sav_service_method}', this.var_service_method_name ) // tested above.






          // Attempt and Service Dates and Times
          .replaceAll('${date_service}', moment(this.job_model.date_service).format('M/D/YYYY'))

          // New Local Times with Full Date.
          // .replaceAll('${date_service_full_words_time_first}', moment(this.job_model.date_service).format('h:mma dddd MMMM Do, YYYY') ) // 
          .replaceAll('${date_service_full_words_time_first}', model.time_service_text + ' ' + moment(this.job_model.date_service).format('dddd MMMM Do, YYYY') ) // 
          // .replaceAll('${date_service_full_words}', moment(this.job_model.date_service).format('h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${date_service_full_words}', moment(this.job_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 




          .replaceAll('${day}', moment(this.job_model.date_service).format('dddd'))
          .replaceAll('${day_number}', moment(this.job_model.date_service).format('Do'))
          .replaceAll('${day_number_simple}', moment(this.job_model.date_service).format('D'))
          .replaceAll('${month}', moment(this.job_model.date_service).format('MMMM'))
          .replaceAll('${month_number}', moment(this.job_model.date_service).format('Mo'))
          .replaceAll('${month_number_simple}', moment(this.job_model.date_service).format('M'))
          .replaceAll('${year}', moment(this.job_model.date_service).format('YYYY'))

          .replaceAll('${service_local}', model.service_local) // region Australia/Perth of service undertaken
          .replaceAll('${time}', model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

          // SAV
          .replaceAll('${sav_service_day}', moment(this.job_model.date_service).format('dddd'))
          .replaceAll('${sav_service_day_number}', moment(this.job_model.date_service).format('Do'))
          .replaceAll('${sav_service_day_number_simple}', moment(this.job_model.date_service).format('D'))
          .replaceAll('${sav_service_month}', moment(this.job_model.date_service).format('MMMM'))
          .replaceAll('${sav_service_month_number}', moment(this.job_model.date_service).format('Mo'))
          .replaceAll('${sav_service_month_number_simple}', moment(this.job_model.date_service).format('M'))
          .replaceAll('${sav_service_year}', moment(this.job_model.date_service).format('YYYY'))

          .replaceAll('${sav_service_service_local}', model.service_local) // region Australia/Perth of service undertaken
          .replaceAll('${sav_time_service}', model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

          .replaceAll('${sav_director_name}', model.director_name)

          // Subject Attempt Address
          .replaceAll('${address_1}', model.address_1)
          .replaceAll('${address_2}', model.address_2)
          .replaceAll('${suburb}', model.suburb)
          .replaceAll('${state}', model.state)
          .replaceAll('${postcode}', model.postcode)
          .replaceAll('${address_full}', model.address_1 +  ' ' + model.address_2 +  ' ' + model.suburb +  ' ' + model.state +  ',  ' + model.postcode )
          // Sav
          .replaceAll('${sav_address_full}', model.address_1 +  ' ' + model.address_2 +  ' ' + model.suburb +  ' ' + model.state +  ',  ' + model.postcode )
          // New address
          .replaceAll('${new_business_name}', model.new_business_name)
          .replaceAll('${new_address_1}', model.new_address_1)
          .replaceAll('${new_address_2}', model.new_address_2)
          .replaceAll('${new_suburb}', model.new_suburb)
          .replaceAll('${new_state}', model.new_state)
          .replaceAll('${new_postcode}', model.new_postcode)
          .replaceAll('${new_address_full}', model.new_address_1 +  ' ' + model.new_address_2 +  ' ' + model.new_suburb +  ' ' + model.new_state +  ',  ' + model.new_postcode )

          .replaceAll('${service_number}', model.service_number)

          .replaceAll('${fellow_occupants_name}', model.fellow_occupants_name)
          .replaceAll('${fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  model.fellow_occupants_name)
          .replaceAll('${person_spoken_with}', model.person_spoken_with)
          .replaceAll('${person_type}', model.person_type)
          .replaceAll('${person_spoken_with_advised}', model.person_spoken_with_advised)
        
    
          .replaceAll('${vehicles}', model.vehicles)

          .replaceAll('${vehicles_notes}', model.vehicles_notes)
          .replaceAll('${neighbours}', model.neighbours)
          .replaceAll('${neighbours_notes}', model.neighbours_notes)
          .replaceAll('${calling_card}', model.calling_card)
          .replaceAll('${calling_card_notes}', model.calling_card_notes)
          .replaceAll('${postal_mail}', model.postal_mail)
          .replaceAll('${postal_mail_notes}', model.postal_mail_notes)
          .replaceAll('${phone_call}', model.phone_call)
          .replaceAll('${phone_call_notes}', model.phone_call_notes)
         
          .replaceAll('${attempts}', model.attempts)
          .replaceAll('${attempts_notes}', model.attempts_notes)
          .replaceAll('${authorised_employee_name}', model.authorised_employee_name)
          .replaceAll('${authorised_employee_job_title}', model.authorised_employee_job_title)
          .replaceAll('${authorised_employee_sex}', model.authorised_employee_sex)
          .replaceAll('${office_business_name}', model.office_business_name)

          .replaceAll('${witness_name}', model.witness_name)
          .replaceAll('${witness_business_name}', model.witness_business_name)
          .replaceAll('${witness_address}', model.witness_address_1 + ' ' + model.witness_address_2 + ' ' +  model.witness_suburb + ' ' + model.witness_state + ', ' + model.postcode  ) // 

          .replaceAll('${witness_address_1}', model.witness_address_1)
          .replaceAll('${witness_address_2}', model.witness_address_2)
          .replaceAll('${witness_state}', model.witness_state)
          .replaceAll('${witness_suburb}', model.witness_suburb)
          .replaceAll('${witness_country}', model.witness_country)
          .replaceAll('${witness_postcode}', model.witness_postcode)

          .replaceAll('${person_in_charge_of_prison_name}', model.person_in_charge_of_prison_name)
          .replaceAll('${person_in_charge_of_prison_occupation}', model.person_in_charge_of_prison_occupation)
          .replaceAll('${subject_contact_email_id}', model.subject_contact_email_id)
          .replaceAll('${email_address_served}', model.email_address_served)
          .replaceAll('${director_name}', model.director_name)
          .replaceAll('${service_under_order}', model.service_under_order)
          .replaceAll('${business_name}', model.business_name)

          .replaceAll('${general_notes}', model.general_notes)


     // New HTML Varibles

     // Might have to create a PHP Function to decode the variable...  I could always try the other function.
    //  .replaceAll('${general_notes_HTML}', document.getElementById('general_notes_HTML').innerText ) // needs to be decoded? // see new function
    
    // .replaceAll('${general_notes_HTML}',  unescape(model.general_notes_HTML)) // needs to be decoded? // see new function - this decodes but leaves all the HTML div tags and content
    
     //  .replaceAll('${general_notes_HTML}',  this.escapeHtml(unescape(model.general_notes_HTML))) // needs to be decoded? // see new function
   
    // .replaceAll('${general_notes_HTML}',  decodeURIComponent(model.general_notes_HTML)) // needs to be decoded? // see new function

    
    //  .replaceAll('${general_notes_HTML}',  ) // needs to be decoded? // see new function THIS WORKS but requires a hidden field in the template
    // .replaceAll('${general_notes_HTML}',  document.getElementById('general_notes_HTML_rendered_hidden').innerHTML ) // needs to be decoded? // see new function - this one gets the rendered HTML from a hidden fied on the page and (unner text only) and sets as the variable.

      // :: Try getting the field without having to create a hidden field.
      .replaceAll('${general_notes_HTML}',   unescape(this.transform2(model.general_notes_HTML)) ) // needs to be decoded? // see new function - this one gets the rendered HTML from a hidden fied on the page and (unner text only) and sets as the variable.
      .replaceAll('${general_notes}',   unescape(this.transform2(model.general_notes_HTML)) ) // replace original only use this for create.

          .replaceAll('${email_contents}', model.email_contents)
          .replaceAll('${phone_number}', model.phone_number)
          .replaceAll('${is_count}', model.is_count)
          .replaceAll('${property_images}', model.property_images)
          .replaceAll('${attach_file_array_name}', model.attach_file_array_name)
          .replaceAll('${property_occupied}', model.property_occupied)
          .replaceAll('${property_forsale_or_lease_sign}', model.property_forsale_or_lease_sign)
          .replaceAll('${property_sign_images}', model.property_sign_images)
          .replaceAll('${property_forsale_or_lease_sign_details}', model.property_forsale_or_lease_sign_details)
          .replaceAll('${property_agent_name}', model.property_agent_name)
          .replaceAll('${property_agency_name}', model.property_agency_name)
          .replaceAll('${property_agency_contact_numbers}', model.property_agency_contact_numbers)
          .replaceAll('${property_mail}', model.property_mail)
          .replaceAll('${property_mail_images}', model.property_mail_images)
          .replaceAll('${property_mail_details}', model.property_mail_details)
          .replaceAll('${property_vehicles_sighted}', model.property_vehicles_sighted)
          .replaceAll('${property_vehicles_sighted_details}', model.property_vehicles_sighted_details)
          .replaceAll('${property_vehicles_images}', model.property_vehicles_images)
          .replaceAll('${property_v_make}', model.property_v_make)
          .replaceAll('${property_v_model}', model.property_v_model)
          .replaceAll('${property_v_plate}', model.property_v_plate)
          .replaceAll('${property_v_rego_state}', model.property_v_rego_state)
          .replaceAll('${property_pets}', model.property_pets)
          .replaceAll('${property_pets_details}', model.property_pets_details)
          .replaceAll('${property_pets_images}', model.property_pets_images)
          .replaceAll('${property_occupancy}', model.property_occupancy)
          .replaceAll('${property_occupancy_details}', model.property_occupancy_details)
          .replaceAll('${property_occupancy_images}', model.property_occupancy_images)
          .replaceAll('${property_o_name}', model.property_o_name)
          .replaceAll('${property_o_contact_numbers}', model.property_o_contact_numbers)
          .replaceAll('${property_o_lease_details}', model.property_o_lease_details)
          .replaceAll('${property_o_lease_date}', model.property_o_lease_date)
          .replaceAll('${property_o_landlord_contacts}', model.property_o_landlord_contacts)
          .replaceAll('${property_condition}', model.property_condition)
          .replaceAll('${property_condition_images}', model.property_condition_images)
          .replaceAll('${property_occupied_details}', model.property_occupied_details)
          .replaceAll('${property_type_id}', model.property_type_id)

          .replaceAll('${property_type_details}', model.property_type_details)
          .replaceAll('${property_type_images}', model.property_type_images)


          // Agent Details
          .replaceAll('${agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
          .replaceAll('${agent_first_name}', this.subject_service_agent.first_name)
          .replaceAll('${agent_middle_name}', this.subject_service_agent.middle_name)
          .replaceAll('${agent_surname}', this.subject_service_agent.surname)

          .replaceAll('${agent_address_1}', this.subject_service_agent.address_1)
          .replaceAll('${agent_address_2}', this.subject_service_agent.address_2)
          .replaceAll('${agent_suburb}', this.subject_service_agent.suburb)
          .replaceAll('${agent_state}', this.subject_service_agent.state)
          .replaceAll('${agent_postcode}', this.subject_service_agent.postcode)
          .replaceAll('${agent_adddress_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
          .replaceAll('${agent_qualification}', this.subject_service_agent.qualification)
          .replaceAll('${agent_qualification_number}', this.subject_service_agent.qualification_number)

          .replaceAll('${agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('M/D/YYYY') )
          .replaceAll('${agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

          // CHANGE ThESE to variables not direct connectins to the model so I can minipulate and check before running the replace
          // Current Subject Variables.
          // .replaceAll('${subject_id}', this.subject_model.subject_id)
          // .replaceAll('${subject_number}', this.subject_model.subject_number)
          // .replaceAll('${subject_job_status}', this.subject_model.job_status)

          // WHAT IF A BUSINESS NAME: RUNS ONCE REMEMBER OR DO I LOOP OVER TWO OR THREE TIMES TO ENSURE WE ARE MERGED?
          // .replaceAll('${subject_name}', this.subject_model.first_name + ' ' + this.subject_model.middle_name + ' ' + this.subject_model.surname)
          // .replaceAll('${subject_name_4_doc}', this.subject_model.first_name + '-' + this.subject_model.surname)
          // .replaceAll('${subject_business_name}', this.subject_model.business_name)



          // Changed to varaibles.
          // Subject Details
          .replaceAll('${subject_id}', var_subject_id)
          .replaceAll('${subject_number}', var_subject_number)
          .replaceAll('${subject_job_status}', this.subject_model.job_status)
          .replaceAll('${subject_name}', var_subject_name)
          .replaceAll('${subject_name_4_doc}', var_subject_name_4_doc)
          .replaceAll('${subject_business_name}', var_subject_business_name)

          // All these variables are established ans set above before running the merge fields etc,
          //sav_
          .replaceAll('${sav_subject_name}', var_subject_name)

          // let var_subject_service_fellow_relationship =  this.subject_service_fellow_relationship
          .replaceAll('${sav_subject_relationship_name}', var_subject_service_fellow_relationship)


          // Get the Outcome Name
          // let var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name
          .replaceAll('${service_outcome_name}', this.var_service_outcome_name)
          //sav
          .replaceAll('${sav_service_outcome_name}', this.var_service_outcome_name)

          // Needs testing
          // .replaceAll('${exact_service_method_name}', this.subjectExactServiceMethod.service_method_name) // crrently tgrowing errors

          .replaceAll('${location_status_name}', this.var_location_status_name)
          //sav
          .replaceAll('${sav_location_status_name}', this.var_location_status_name)


          .replaceAll('${location_status_found_name}', this.var_location_status_found_name)
          .replaceAll('${sav_location_status_found_name}', this.var_location_status_found_name)






  return rendered_result;
}
// END NEW EXPERIMENTAL FUNCTION


// Function to remove when HTML in Place -- This allows general notes to be set by either if the HTML field is hidden
if(model.general_notes_HTML == null){
this.set_general_notes = model.general_notes;
}else{
 this.set_general_notes = unescape(this.transform2(model.general_notes_HTML))
}

if(model.property_type_details_HTML == null){this.set_property_type_details_HTML = model.property_type_details; }else{this.set_property_type_details_HTML = unescape(this.transform2(model.property_type_details_HTML));}
if(model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = model.property_occupied_details; }else{this.property_occupied_details_HTML = unescape(this.transform2(model.property_occupied_details_HTML));}
if(model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = unescape(this.transform2(model.property_forsale_or_lease_sign_details_HTML));}

if(model.property_mail_details_HTML == null){this.property_mail_details_HTML = model.property_mail_details; }else{this.property_mail_details_HTML = unescape(this.transform2(model.property_mail_details_HTML));}

if(model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = unescape(this.transform2(model.property_vehicles_sighted_details_HTML));}

if(model.property_pets_details_HTML == null){this.property_pets_details_HTML = model.property_pets_details; }else{this.property_pets_details_HTML = unescape(this.transform2(model.property_pets_details_HTML));}

if(model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = model.property_occupancy_details; }else{this.property_occupancy_details_HTML = unescape(this.transform2(model.property_occupancy_details_HTML));}

if(model.property_condition_HTML == null){this.property_condition_HTML = model.property_condition; }else{this.property_condition_HTML = unescape(this.transform2(model.property_condition_HTML));}

if(model.attempts_notes_HTML == null){this.attempts_notes_HTML = model.attempts_notes; }else{this.attempts_notes_HTML = unescape(this.transform2(model.attempts_notes_HTML));}

if(model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = unescape(this.transform2(model.person_spoken_with_advised_HTML));}

if(model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = model.vehicles_notes; }else{this.vehicles_notes_HTML = unescape(this.transform2(model.vehicles_notes_HTML));}

if(model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = model.neighbours_notes; }else{this.neighbours_notes_HTML = unescape(this.transform2(model.neighbours_notes_HTML));}

if(model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = model.calling_card_notes; }else{this.calling_card_notes_HTML = unescape(this.transform2(model.calling_card_notes_HTML));}

if(model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = model.postal_mail_notes; }else{this.postal_mail_notes_HTML = unescape(this.transform2(model.postal_mail_notes_HTML));}

if(model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = model.phone_call_notes; }else{this.phone_call_notes_HTML = unescape(this.transform2(model.phone_call_notes_HTML));}

if(model.email_contents_HTML == null){this.email_contents_HTML = model.email_contents; }else{this.email_contents_HTML = unescape(this.transform2(model.email_contents_HTML));}

if(model.service_under_order_HTML == null){this.service_under_order_HTML = model.service_under_order; }else{this.service_under_order_HTML = unescape(this.transform2(model.service_under_order_HTML));}

// New null print edition May 2024
let vehicles = model.vehicles;
if(vehicles == 'Our agent observed the following vehicles at the address.'){
  vehicles = ''; // empty for the negative
}else{
  vehicles = model.vehicles;
};

let neighbours = model.neighbours;
if(neighbours == 'Our agent was able to speak to neighbours and had the following conversation.'){
  neighbours = ''; // empty for the negative
}else{
  neighbours = model.neighbours;
};

let calling_card = model.calling_card;
// if(calling_card == 'A calling card was left at the address.'){
//   calling_card = ''; // empty for the negative
// }else{
//   calling_card = model.calling_card;
// };

let postal_mail = model.postal_mail;
if(postal_mail == 'Our agent sighted mail at the address and provided the following further information.'){
  postal_mail = ''; // empty for the negative
}else{
  postal_mail = model.postal_mail;
};

let phone_call = model.phone_call;
if(phone_call == 'A phone call was made'){
  phone_call = ''; // empty for the negative
}else{
  phone_call = model.phone_call;
};


const rendered_result = str2
    // .replaceAll('${f_subject_name}', 'Big Subject')
    // .replaceAll('${f_subject_number}', this.subject_model.subject_number)
    // .replaceAll('${job_instructions_month}', 'January')
    // .replaceAll('${job_instructions_day_number} ', '56')
    // .replaceAll('${job_instructions_year}', this.job_model.job_instructions_year)

// Start of officual Job Vars
.replaceAll('${job_id}', this.job_model.job_id)
.replaceAll('${job_number}', this.job_model.job_number)
.replaceAll('${job_status_code}', this.job_model.job_status_code)
.replaceAll('${owner_trace_code}', this.job_model.owner_trace_code)
.replaceAll('${client_ref}', this.job_model.owner_trace_code)
.replaceAll('${client_reference}', this.job_model.owner_trace_code)
.replaceAll('${job_document_number}', this.job_model.document_number)
.replaceAll('${job_registry_name}', this.job_model.registry_name)
// .replaceAll('${job_registry_name_upper}', job_registry_name_UPPER) // set variables before replaceAll Function

.replaceAll('${job_hearing_date}', this.legalDate.format(this.job_model.hearing_date, 'M/D/YYYY'))
.replaceAll('${hearing_date_full_words_time_first}', this.legalDate.format(this.job_model.hearing_date, 'h:mma dddd MMMM Do, YYYY') ) // equivilent to in PHP :: date("g:ia l jS F Y", strtotime($job_hearing_date))
.replaceAll('${hearing_date_full_words}', this.legalDate.format(this.job_model.hearing_date, 'dddd MMMM Do, YYYY h:mma') )
.replaceAll('${hearing_date}', this.legalDate.format(this.job_model.hearing_date, 'M/D/YYYY'))
.replaceAll('${hearing_day}', this.legalDate.format(this.job_model.hearing_date, 'dddd'))
.replaceAll('${hearing_day_number}', this.legalDate.format(this.job_model.hearing_date, 'Do'))
.replaceAll('${hearing_month}', this.legalDate.format(this.job_model.hearing_date, 'MMMM'))
.replaceAll('${hearing_month_number}', this.legalDate.format(this.job_model.hearing_date, 'Mo'))
.replaceAll('${hearing_month_number_simple}', this.legalDate.format(this.job_model.hearing_date, 'M'))
.replaceAll('${hearing_year}', this.legalDate.format(this.job_model.hearing_date, 'YYYY'))
.replaceAll('${hearing_time}', this.legalDate.format(this.job_model.hearing_date, 'h:mma'))

.replaceAll('${job_judgement_date}', this.legalDate.format(this.job_model.judgement_date, 'M/D/YYYY'))
.replaceAll('${judgement_date_full_words_time_first}', this.legalDate.format(this.job_model.judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${judgement_date_full_words}', this.legalDate.format(this.job_model.judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${judgement_date}', this.legalDate.format(this.job_model.judgement_date, 'M/D/YYYY'))
.replaceAll('${judgement_day}', this.legalDate.format(this.job_model.judgement_date, 'dddd'))
.replaceAll('${judgement_day_number}', this.legalDate.format(this.job_model.judgement_date, 'Do'))
.replaceAll('${judgement_month}', this.legalDate.format(this.job_model.judgement_date, 'MMMM'))
.replaceAll('${judgement_month_number}', this.legalDate.format(this.job_model.judgement_date, 'Mo'))
.replaceAll('${judgement_month_number_simple}', this.legalDate.format(this.job_model.judgement_date, 'M'))
.replaceAll('${judgement_year}', this.legalDate.format(this.job_model.judgement_date, 'YYYY'))
.replaceAll('${judgement_time}', this.legalDate.format(this.job_model.judgement_date, 'h:mma'))

.replaceAll('${job_filing_date}', this.legalDate.format(this.job_model.filing_date, 'M/D/YYYY'))
.replaceAll('${filing_date_full_words_time_first}', this.legalDate.format(this.job_model.filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${filing_date_full_words}', this.legalDate.format(this.job_model.filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${filing_date}', this.legalDate.format(this.job_model.filing_date, 'M/D/YYYY'))
.replaceAll('${filing_day}', this.legalDate.format(this.job_model.filing_date, 'dddd'))
.replaceAll('${filing_day_number}', this.legalDate.format(this.job_model.filing_date, 'Do'))
.replaceAll('${filing_month}', this.legalDate.format(this.job_model.filing_date, 'MMMM'))
.replaceAll('${filing_month_number}', this.legalDate.format(this.job_model.filing_date, 'Mo'))
.replaceAll('${filing_month_number_simple}', this.legalDate.format(this.job_model.filing_date, 'M'))
.replaceAll('${filing_year}', this.legalDate.format(this.job_model.filing_date, 'YYYY'))
.replaceAll('${filing_time}', this.legalDate.format(this.job_model.filing_date, 'h:mma'))


.replaceAll('${job_instructions_date}', this.legalDate.format(this.job_model.instructions_date, 'M/D/YYYY'))
.replaceAll('${instructions_date_full_words_time_first}', this.legalDate.format(this.job_model.instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${instructions_date_full_words}', this.legalDate.format(this.job_model.instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${instructions_date}', this.legalDate.format(this.job_model.instructions_date, 'M/D/YYYY'))
.replaceAll('${instructions_day}', this.legalDate.format(this.job_model.instructions_date, 'dddd'))
.replaceAll('${instructions_day_number}', this.legalDate.format(this.job_model.instructions_date, 'Do'))
.replaceAll('${instructions_month}', this.legalDate.format(this.job_model.instructions_date, 'MMMM'))
.replaceAll('${instructions_month_number}', this.legalDate.format(this.job_model.instructions_date, 'Mo'))
.replaceAll('${instructions_month_number_simple}', this.legalDate.format(this.job_model.instructions_date, 'M'))
.replaceAll('${instructions_year}', this.legalDate.format(this.job_model.instructions_date, 'YYYY'))
.replaceAll('${instructions_time}', this.legalDate.format(this.job_model.instructions_date, 'h:mma'))

.replaceAll('${job_aos_date}', this.legalDate.format(this.job_model.aos_date, 'M/D/YYYY'))
.replaceAll('${aos_date_full_words_time_first}', this.legalDate.format(this.job_model.aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${aos_date_full_words}', this.legalDate.format(this.job_model.aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${aos_date}', this.legalDate.format(this.job_model.aos_date, 'M/D/YYYY'))
.replaceAll('${aos_day}', this.legalDate.format(this.job_model.aos_date, 'dddd'))
.replaceAll('${aos_day_number}', this.legalDate.format(this.job_model.aos_date, 'Do'))
.replaceAll('${aos_month}', this.legalDate.format(this.job_model.aos_date, 'MMMM'))
.replaceAll('${aos_month_number}', this.legalDate.format(this.job_model.aos_date, 'Mo'))
.replaceAll('${aos_month_number_simple}', this.legalDate.format(this.job_model.aos_date, 'M'))
.replaceAll('${aos_year}', this.legalDate.format(this.job_model.aos_date, 'YYYY'))
.replaceAll('${aos_time}', this.legalDate.format(this.job_model.aos_date, 'h:mma'))

// Current Attempt Variables
.replaceAll('${f_attempt_type_id}', model.subject_attempt_type_id)
.replaceAll('${f_attempt_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
.replaceAll('${f_attempt_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales
.replaceAll('${type_id}', model.subject_attempt_type_id)
.replaceAll('${type_name}', this.var_subject_attempt_type_name ) // run a function with return;
.replaceAll('${type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

.replaceAll('${f_attempt_subject_type_id}', model.subject_attempt_type_id)
.replaceAll('${f_attempt_subject_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
.replaceAll('${f_attempt_subject_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales
.replaceAll('${subject_type_id}', model.subject_attempt_type_id)
.replaceAll('${subject_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
.replaceAll('${subject_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

.replaceAll('${f_service_method_id}', model.subject_service_method_id)
.replaceAll('${f_service_method_name}', this.var_service_method_name ) // tested above.
.replaceAll('${service_method_id}', model.subject_service_method_id)
.replaceAll('${service_method_name}', this.var_service_method_name ) // tested above.

.replaceAll('${f_attempt_service_method_id}', model.subject_service_method_id)
.replaceAll('${f_attempt_service_method_name}', this.var_service_method_name ) // tested above.

// SAV
.replaceAll('${sav_service_method}', this.var_service_method_name ) // tested above.
.replaceAll('${sav_director_name}', model.director_name)




// Attempt and Service Dates and Times
.replaceAll('${date_service}', moment(model.date_service).format('M/D/YYYY'))

// New Local Times with Full Date.
// .replaceAll('${date_service_full_words_time_first}', moment(this.job_model.date_service).format('h:mma dddd MMMM Do, YYYY') ) // 

.replaceAll('${date_service_full_words_time_first}', model.time_service_text + ' ' + moment(model.date_service).format('dddd MMMM Do, YYYY') ) // 
// .replaceAll('${date_service_full_words}', moment(this.job_model.date_service).format('h:mma dddd MMMM Do, YYYY') ) 
// + ' ' + model.time_service_text 
.replaceAll('${date_service_full_words}', moment(model.date_service).format('dddd MMMM Do, YYYY') ) 

.replaceAll('${date_service_and_time_full_words}', moment(model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text   ) // 

.replaceAll('${day}', moment(model.date_service).format('dddd'))
.replaceAll('${day_number}', moment(model.date_service).format('Do'))
.replaceAll('${day_number_simple}', moment(model.date_service).format('D'))
.replaceAll('${month}', moment(model.date_service).format('MMMM'))
.replaceAll('${month_number}', moment(model.date_service).format('Mo'))
.replaceAll('${month_number_simple}', moment(model.date_service).format('M'))
.replaceAll('${year}', moment(model.date_service).format('YYYY'))

.replaceAll('${service_local}', model.service_local) // region Australia/Perth of service undertaken

// Replace above to choose correct Times. // Testing this for correct paragraph times and dates.
// .replaceAll('${time}', model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service
.replaceAll('${time}', this.var_time_service) //$_set_service_time - Fixed and set time of attempt and service

// SAV
.replaceAll('${sav_service_day}', moment(model.date_service).format('dddd'))
.replaceAll('${sav_service_day_number}', moment(model.date_service).format('Do'))
.replaceAll('${sav_service_day_number}', moment(model.date_service).format('Do'))

.replaceAll('${sav_service_day_number_simple}', moment(model.date_service).format('D'))
.replaceAll('${sav_service_month}', moment(model.date_service).format('MMMM'))
.replaceAll('${sav_service_month_number}', moment(model.date_service).format('Mo'))
.replaceAll('${sav_service_month_number_simple}', moment(model.date_service).format('M'))
.replaceAll('${sav_service_year}', moment(model.date_service).format('YYYY'))

.replaceAll('${sav_service_service_local}', model.service_local) // region Australia/Perth of service undertaken


// .replaceAll('${sav_time_service}', model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service
.replaceAll('${sav_time_service}', this.var_time_service) //$_set_service_time - Fixed and set time of attempt and service



// Subject Attempt Address
.replaceAll('${address_1}', model.address_1)
.replaceAll('${address_2}', model.address_2)
.replaceAll('${suburb}', model.suburb)
.replaceAll('${state}', model.state)
.replaceAll('${postcode}', model.postcode)
.replaceAll('${address_full}', model.address_1 +  ' ' + model.address_2 +  ' ' + model.suburb +  ' ' + model.state +  ',  ' + model.postcode )
// Sav
.replaceAll('${sav_address_full}', model.address_1 +  ' ' + model.address_2 +  ' ' + model.suburb +  ' ' + model.state +  ',  ' + model.postcode )
// New address
.replaceAll('${new_business_name}', model.new_business_name)
.replaceAll('${new_address_1}', model.new_address_1)
.replaceAll('${new_address_2}', model.new_address_2)
.replaceAll('${new_suburb}', model.new_suburb)
.replaceAll('${new_state}', model.new_state)
.replaceAll('${new_postcode}', model.new_postcode)
.replaceAll('${new_address_full}', model.new_address_1 +  ' ' + model.new_address_2 +  ' ' + model.new_suburb +  ' ' + model.new_state +  ',  ' + model.new_postcode )

.replaceAll('${service_number}', model.service_number)



// These may be different for attendances and servives ??? need to check. and crate as variable in an if satement above if true.
.replaceAll('${fellow_occupants_name}', model.fellow_occupants_name)
.replaceAll('${sav_fellow_occupants_name}', model.fellow_occupants_name)
.replaceAll('${fellow_occupants_sex}', model.fellow_occupants_sex)
// changed october 2023
// .replaceAll('${fellow_occupants_name}', model.person_spoken_with)
// .replaceAll('${sav_fellow_occupants_name}', model.person_spoken_with)
// .replaceAll('${fellow_occupants_sex}', model.person_type)
.replaceAll('${fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  model.fellow_occupants_name)


.replaceAll('${person_spoken_with}', model.person_spoken_with)
.replaceAll('${person_type}', model.person_type)
// .replaceAll('${person_spoken_with_advised}', model.person_spoken_with_advised)
// .replaceAll('${person_spoken_with_advised}',   unescape(this.transform2(model.person_spoken_with_advised_HTML)) ) 
.replaceAll('${person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 


// .replaceAll('${vehicles}', model.vehicles)
.replaceAll('${vehicles}', vehicles) // updated for negatives


// .replaceAll('${vehicles_notes}', model.vehicles_notes)
// .replaceAll('${vehicles_notes}',   unescape(this.transform2(model.vehicles_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.
// .replaceAll('${neighbours}', model.neighbours)
.replaceAll('${neighbours}', neighbours) // changed for nulls


// .replaceAll('${neighbours_notes}', model.neighbours_notes)
// .replaceAll('${neighbours_notes}',   unescape(this.transform2(model.neighbours_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

// .replaceAll('${calling_card}', model.calling_card)
.replaceAll('${calling_card}', calling_card) //  upgraded for nulls


// .replaceAll('${calling_card_notes}', model.calling_card_notes)
// .replaceAll('${calling_card_notes}',   unescape(this.transform2(model.calling_card_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

// .replaceAll('${postal_mail}', model.postal_mail)
.replaceAll('${postal_mail}', postal_mail) // updated for null

// .replaceAll('${postal_mail_notes}', model.postal_mail_notes)
// .replaceAll('${postal_mail_notes}',   unescape(this.transform2(model.postal_mail_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

// .replaceAll('${phone_call}', model.phone_call)
.replaceAll('${phone_call}', phone_call)

// .replaceAll('${phone_call_notes}', model.phone_call_notes)
// .replaceAll('${phone_call_notes}',   unescape(this.transform2(model.phone_call_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll('${attempts}', model.attempts)
// .replaceAll('${attempts_notes}', model.attempts_notes)
// .replaceAll('${attempts_notes}',   unescape(this.transform2(model.attempts_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll('${authorised_employee_name}', model.authorised_employee_name)
.replaceAll('${authorised_employee_job_title}', model.authorised_employee_job_title)
.replaceAll('${authorised_employee_sex}', model.authorised_employee_sex)
.replaceAll('${office_business_name}', model.office_business_name)

.replaceAll('${witness_name}', model.witness_name)
.replaceAll('${witness_business_name}', model.witness_business_name)
.replaceAll('${witness_address}', model.witness_address_1 + ' ' + model.witness_address_2 + ' ' +  model.witness_suburb + ' ' + model.witness_state + ', ' + model.postcode  ) // 

.replaceAll('${witness_address_1}', model.witness_address_1)
.replaceAll('${witness_address_2}', model.witness_address_2)
.replaceAll('${witness_state}', model.witness_state)
.replaceAll('${witness_suburb}', model.witness_suburb)
.replaceAll('${witness_country}', model.witness_country)
.replaceAll('${witness_postcode}', model.witness_postcode)

.replaceAll('${person_in_charge_of_prison_name}', model.person_in_charge_of_prison_name)
.replaceAll('${person_in_charge_of_prison_occupation}', model.person_in_charge_of_prison_occupation)
.replaceAll('${subject_contact_email_id}', model.subject_contact_email_id)
.replaceAll('${email_address_served}', model.email_address_served)
.replaceAll('${director_name}', model.director_name)
// .replaceAll('${service_under_order}', model.service_under_order)

.replaceAll('${business_name}', model.business_name)
.replaceAll('${f_service_business_name}', model.business_name)

// .replaceAll('${general_notes}', model.general_notes) // old system pre Nov 23
// :: if statement before upgrade
// .replaceAll('${general_notes}',   unescape(this.transform2(model.general_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${general_notes}',  this.set_general_notes ) // replace original only use this for create.

     // Might have to create a PHP Function to decode the variable...  I could always try the other function.
    //  .replaceAll('${general_notes_HTML}', document.getElementById('general_notes_HTML').innerText ) // needs to be decoded? // see new function
    
    // .replaceAll('${general_notes_HTML}',  unescape(model.general_notes_HTML)) // needs to be decoded? // see new function - this decodes but leaves all the HTML div tags and content
    
     //  .replaceAll('${general_notes_HTML}',  this.escapeHtml(unescape(model.general_notes_HTML))) // needs to be decoded? // see new function
   
    // .replaceAll('${general_notes_HTML}',  decodeURIComponent(model.general_notes_HTML)) // needs to be decoded? // see new function

    
    //  .replaceAll('${general_notes_HTML}',  ) // needs to be decoded? // see new function THIS WORKS but requires a hidden field in the template
    // .replaceAll('${general_notes_HTML}',  document.getElementById('general_notes_HTML_rendered_hidden').innerHTML ) // needs to be decoded? // see new function - this one gets the rendered HTML from a hidden fied on the page and (unner text only) and sets as the variable.

      // :: Try getting the field without having to create a hidden field.
      .replaceAll('${general_notes_HTML}',   unescape(this.transform2(model.general_notes_HTML)) ) // needs to be decoded? // see new function - this one gets the rendered HTML from a hidden fied on the page and (unner text only) and sets as the variable.









// .replaceAll('${email_contents}', model.email_contents)
// .replaceAll('${email_contents}', unescape(this.transform2(model.email_contents_HTML)) ) // replace original only use this for create.
.replaceAll('${email_contents}', this.email_contents_HTML ) // replace original only use this for create.
.replaceAll('${service_under_order}', this.service_under_order_HTML ) // replace original only use this for create.
.replaceAll('${service_under_order_HTML}', this.service_under_order_HTML ) // replace original only use this for create.


.replaceAll('${phone_number}', model.phone_number)
.replaceAll('${is_count}', model.is_count)
.replaceAll('${property_images}', model.property_images)
.replaceAll('${attach_file_array_name}', model.attach_file_array_name)
.replaceAll('${property_occupied}', model.property_occupied)
.replaceAll('${property_forsale_or_lease_sign}', model.property_forsale_or_lease_sign)
.replaceAll('${property_sign_images}', model.property_sign_images)
// .replaceAll('${property_forsale_or_lease_sign_details}', model.property_forsale_or_lease_sign_details)
// .replaceAll('${property_forsale_or_lease_sign_details}',   unescape(this.transform2(model.property_forsale_or_lease_sign_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.

.replaceAll('${property_agent_name}', model.property_agent_name)
.replaceAll('${property_agency_name}', model.property_agency_name)
.replaceAll('${property_agency_contact_numbers}', model.property_agency_contact_numbers)
.replaceAll('${property_mail}', model.property_mail)
.replaceAll('${property_mail_images}', model.property_mail_images)
// .replaceAll('${property_mail_details}', model.property_mail_details)
// .replaceAll('${property_mail_details}', unescape(this.transform2(model.property_mail_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.
.replaceAll('${property_vehicles_sighted}', model.property_vehicles_sighted)
// .replaceAll('${property_vehicles_sighted_details}', model.property_vehicles_sighted_details)
// .replaceAll('${property_vehicles_sighted_details}', unescape(this.transform2(model.property_vehicles_sighted_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
.replaceAll('${property_vehicles_images}', model.property_vehicles_images)
.replaceAll('${property_v_make}', model.property_v_make)
.replaceAll('${property_v_model}', model.property_v_model)
.replaceAll('${property_v_plate}', model.property_v_plate)
.replaceAll('${property_v_rego_state}', model.property_v_rego_state)
.replaceAll('${property_pets}', model.property_pets)
// .replaceAll('${property_pets_details}', model.property_pets_details)
// .replaceAll('${property_pets_details}', unescape(this.transform2(model.property_pets_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
.replaceAll('${property_pets_images}', model.property_pets_images)
.replaceAll('${property_occupancy}', model.property_occupancy)
// .replaceAll('${property_occupancy_details}', model.property_occupancy_details)
// .replaceAll('${property_occupancy_details}', unescape(this.transform2(model.property_occupancy_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll('${property_occupancy_images}', model.property_occupancy_images)
.replaceAll('${property_o_name}', model.property_o_name)
.replaceAll('${property_o_contact_numbers}', model.property_o_contact_numbers)
.replaceAll('${property_o_lease_details}', model.property_o_lease_details)
.replaceAll('${property_o_lease_date}', model.property_o_lease_date)
.replaceAll('${property_o_landlord_contacts}', model.property_o_landlord_contacts)
// .replaceAll('${property_condition}', model.property_condition)
// .replaceAll('${property_condition}', unescape(this.transform2(model.property_condition_HTML)) ) // replace original only use this for create.
.replaceAll('${property_condition}', this.property_condition_HTML ) // replace original only use this for create.
.replaceAll('${property_condition_images}', model.property_condition_images)
// .replaceAll('${property_occupied_details}', model.property_occupied_details)
// .replaceAll('${property_occupied_details}', unescape(this.transform2(model.property_occupied_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.
.replaceAll('${property_type_id}', model.property_type_id)


// .replaceAll('${property_type_details}', model.property_type_details)
// .replaceAll('${property_type_details}', unescape(this.transform2(model.property_type_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.

.replaceAll('${property_type_images}', model.property_type_images)

  // Missing Report Client Name - And Report Client Details for the paragraph

  .replaceAll('${job_report_client_name}', this.job_report_client.name)
  .replaceAll('${job_client_report_name}', this.job_report_client.name)
  .replaceAll('${job_client_report_name_upper}', this.job_report_client.name)

  .replaceAll('${job_client_report_phone}', this.job_report_client.phone)
  .replaceAll('${job_client_report_address_1}', this.job_report_client.address_1)
  .replaceAll('${job_client_report_address_2}', this.job_report_client.address_2)
  .replaceAll('${job_client_report_suburb}', this.job_report_client.suburb)
  .replaceAll('${job_client_report_state}', this.job_report_client.state)
  .replaceAll('${job_client_report_postcode}', this.job_report_client.postcode)
  .replaceAll('${job_client_report_country}', this.job_report_client.country)
  .replaceAll('${job_client_report_brand_type_id}', this.job_report_client.brand_type_id)
  .replaceAll('${job_client_report_notes}', this.job_report_client.brand_notes)
  .replaceAll('${job_client_report_fax}', this.job_report_client.fax)
  .replaceAll('${job_client_report_email}', this.job_report_client.email)
  .replaceAll('${job_client_report_website}', this.job_report_client.website)
  .replaceAll('${job_client_report_postal_address_1}', this.job_report_client.postal_address_1)
  .replaceAll('${job_client_report_postal_address_2}', this.job_report_client.postal_address_2)
  .replaceAll('${job_client_report_postal_suburb}', this.job_report_client.postal_suburb)
  .replaceAll('${job_client_report_postal_state}', this.job_report_client.postal_state)
  .replaceAll('${job_client_report_postal_postcode}', this.job_report_client.postal_postcode)
  .replaceAll('${job_client_report_postal_country}', this.job_report_client.postal_country)
  .replaceAll('${job_client_report_myob_id}', this.job_report_client.myob_id)
  .replaceAll('${job_client_report_accounts_email_address}', this.job_report_client.accounts_email_address)
  .replaceAll('${job_client_report_brand_type}', this.job_report_client.brand_type_id)
  


// Agent Details
.replaceAll('${agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
.replaceAll('${agent_first_name}', this.subject_service_agent.first_name)
.replaceAll('${agent_middle_name}', this.subject_service_agent.middle_name)
.replaceAll('${agent_surname}', this.subject_service_agent.surname)

.replaceAll('${agent_address_1}', this.subject_service_agent.address_1)
.replaceAll('${agent_address_2}', this.subject_service_agent.address_2)
.replaceAll('${agent_suburb}', this.subject_service_agent.suburb)
.replaceAll('${agent_state}', this.subject_service_agent.state)
.replaceAll('${agent_postcode}', this.subject_service_agent.postcode)
.replaceAll('${agent_adddress_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
.replaceAll('${agent_qualification}', this.subject_service_agent.qualification)
.replaceAll('${agent_qualification_number}', this.subject_service_agent.qualification_number)

.replaceAll('${agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('M/D/YYYY') )
.replaceAll('${agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

// CHANGE ThESE to variables not direct connectins to the model so I can minipulate and check before running the replace
// Current Subject Variables.
// .replaceAll('${subject_id}', this.subject_model.subject_id)
// .replaceAll('${subject_number}', this.subject_model.subject_number)
// .replaceAll('${subject_job_status}', this.subject_model.job_status)

// WHAT IF A BUSINESS NAME: RUNS ONCE REMEMBER OR DO I LOOP OVER TWO OR THREE TIMES TO ENSURE WE ARE MERGED?
// .replaceAll('${subject_name}', this.subject_model.first_name + ' ' + this.subject_model.middle_name + ' ' + this.subject_model.surname)
// .replaceAll('${subject_name_4_doc}', this.subject_model.first_name + '-' + this.subject_model.surname)
// .replaceAll('${subject_business_name}', this.subject_model.business_name)



// Changed to varaibles.
// Subject Details
.replaceAll('${subject_id}', var_subject_id)
.replaceAll('${subject_number}', var_subject_number)
.replaceAll('${subject_job_status}', this.subject_model.job_status)
.replaceAll('${subject_name}', var_subject_name)
.replaceAll('${subject_name_4_doc}', var_subject_name_4_doc)
.replaceAll('${subject_business_name}', var_subject_business_name)





// All these variables are established ans set above before running the merge fields etc,
//sav_
.replaceAll('${sav_subject_name}', var_subject_name)

//tested working
// let var_subject_service_fellow_relationship =  this.subject_service_fellow_relationship
.replaceAll('${sav_subject_relationship_name}', var_subject_service_fellow_relationship)
.replaceAll('${subject_relationship_name}', var_subject_service_fellow_relationship)


// Get the Outcome Name
// let var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name
.replaceAll('${service_outcome_name}', this.var_service_outcome_name)
//sav
.replaceAll('${sav_service_outcome_name}', this.var_service_outcome_name)

// Needs testing Exact Service Meithod Name
// .replaceAll('${exact_service_method_name}', this.subjectExactServiceMethod.service_method_name) // crrently tgrowing errors
.replaceAll('${exact_service_method_name}', this.var_exact_service_method_name) //

// .replaceAll('${exact_service_method_name}', model.exact_service_method) // if a srvive ????? // required


.replaceAll('${location_status_name}', this.var_location_status_name)
//sav -- 
.replaceAll('${sav_location_status_name}', this.var_location_status_name)


.replaceAll('${location_status_found_name}', this.var_location_status_found_name)
.replaceAll('${sav_location_status_found_name}', this.var_location_status_found_name)


.replaceAll('${f_attemot_subject_type_name}', var_subject_type_name)
// .replaceAll('${f_attemot_subject_type_name_upper}', this.subject_job_subject_type.job_subject_type_name.toUpperCase())
.replaceAll('${subject_type_name}', var_subject_type_name)
.replaceAll('${sav_subject_type_name}', var_subject_type_name)


// was missing octoner 2023
.replaceAll('${property_type_name}', this.var_property_type_name)
// .replaceAll('${property_type_name}', 'de name')

// rendered_result.replaceAll('${subject_name}', this.subject_model.job_status)








// hide anything null or undefined.
  .replaceAll('${undefined}', '')
  .replaceAll('${null}', '')
  .replaceAll('undefined', '') // makes all undefined print empty
  .replaceAll('null', '') // makes all undefined print empty





    /*
    Job Variables as merge fiels
str.toUpperCase( ) // function string to upper

            $templateProcessor->setValue($f_starter . 'property_occupied_details' , $v->property_occupied_details);
            $templateProcessor->setValue($f_starter . 'property_type_id' , $v->property_type_id);

             $templateProcessor->setValue($f_starter . 'property_type_details' , $v->property_type_details);
            $templateProcessor->setValue($f_starter . 'property_type_images' , $v->property_type_images);



// Mussing and yet to do
    
$templateProcessor->setValue($f_starter . 'exact_service_method_name' , $json_serviceEM[0]->exact_service_method_name);
   $templateProcessor->setValue($f_starter . 'subject_relationship_name' ,  $json_serviceR[0]->subject_relationship_name);   


            $templateProcessor->setValue($f_starter . 'subject_name' , $subject_name);


         

                        $templateProcessor->setValue($f_starter . 'subject_file_number' , ucfirst($file_number));


            $templateProcessor->setValue($f_starter . 'subject_type_name' , $json_serviceST[0]->job_subject_type_name);
            $templateProcessor->setValue($f_starter . 'subject_type_name_upper' , strtoupper($json_serviceST[0]->job_subject_type_name));

            // July 2022 Additions
            $templateProcessor->setValue($f_starter . 'subject_number' , $v->subject_number);

             $templateProcessor->setValue($f_starter . 'service_file_array' , $sfa_text);

              $templateProcessor->setValue($f_starter . 'property_type_name' , $json_servicePT[0]->property_type_name);

    */



// console.log('JObVar1: ' + this.job_model.job_id);

    // this.current_job -- job is already looked up onit() - from JobSubject


      // Goal is to make a function that runs over the rendered result again.
      // This Funtion Just needs to find Once.????





     this.model.service_paragraph_rendered = rendered_result;
     this.attemptForm.controls['service_paragraph_rendered'].patchValue(rendered_result);


  

     // Count the subjects
     setTimeout(() => {  
      // need to reset the counts...
   // Push model ready for muliptes
   this.pushBaseModel(model)
}, 1250); // was1250 --- needs to do this so that all variables can be eset correctly.

// Filled by running a the function above
    //  this.model.service_paragraph = str3;
    // this.attemptForm.controls['service_paragraph'].patchValue(str3);



/// I wanting. Run again - use const rendered?_result and run .replaceall()


    // console.log(rendered_result);

// end merge varibales and string replace funcitons


            // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
            // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
            // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

            // let new_model = {
            //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
            // }
            // this.getSystemSubjectTemplateDocsArray(new_model);

            // let new_model_b = {
            //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
            // }
            // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

            
            // let new_model_c = {
            //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
            // }
            // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);

// Load all condition arrays from the subject_service_outcome_templates datatable (ssot_condition_arrays.)

//  // Load all the conditions
//   this.getSubjectServicesOutcomeTemplates(data)

        // this.getSystemLogType(data.system_log_type_id);

        // this.toastr.success("Paragraph Refrehsed")

      },
      err => console.error(err.status)
    );
}

// QuickVariable Functions

   
getSubjectServiceType_Q(subject_service_type_id) {
  this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
     data => { 
      // this.subject_service_type = data;
      let res = data[0]
      this.subject_service_type = DataUtil.parse.parseJson(res);
   


      
      // return res.subject_service_type_name
      // if ( subject_service_type_id <= 0 ){
      //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
      //   this.selected_subject_service_type_description = '';
      //   this.selected_subject_service_type_instructions = '';
      //   this.selected_subject_service_type_staff_instructions = '';

      // } else{
      // this.selected_subject_service_type_description = res.subject_service_type_description;
      // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
      // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
      // }

      // // initiate the change of service rule if different or select from drop down.
      // if (subject_service_type_id > 1) {
      // this.setJobServiceRule(res.job_service_rule_id_change_to);
      // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
      // }

    },
     err => console.log(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getSubjectServiceOutcome_Q(subject_service_outcome_id) {
  this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subjectServiceOutcome = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }

  
 getSubjectLocationStatus_Q(subject_location_status_id) {
  this._demoService.getSubjectLocationStatus(subject_location_status_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subjectLocationStatus = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }


  getSubjectLocationStatusFound_Q(subject_location_status_found_id) {
    this._demoService.getSubjectLocationStatusFound(subject_location_status_found_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectLocationStatusFound = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }


  getSubjectExactServiceMethod_Q(exact_service_method_id) {
    this._demoService.getExactServiceMethod(exact_service_method_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectExactServiceMethod = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }
  



 getSubjectAttemptType_Q(subject_service_type_id) {
  this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subject_attempt_type = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }

  getSubjectRelationship_Q(subject_relationship_id) {
    this._demoService.getSubjectRelationship(subject_relationship_id).subscribe(
      data => { 
        let res = data[0]
        this.serviceFellowRelationship = data;
        this.subject_service_fellow_relationship = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }


 getBrand_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.subject_service_agent = DataUtil.parse.parseJson(res);
          // this.allClientEmailRecipients = data;
  
          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand Loaded.')
      );
    }

    getBrand_report_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
// this.toastr.info('Setting and Confirming Details')

          let res = data[0];
          this.job_report_client = DataUtil.parse.parseJson(res);
          // this.allClientEmailRecipients = data;
  
          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand Loaded.')
      );
    }


    getServiceMethod_Q(subject_service_method_id) {
      this._demoService.getServiceMethod(subject_service_method_id).subscribe(
        data => { 
          let res = data[0]
          this.serviceMethod = data;
          this.subject_service_method = DataUtil.parse.parseJson(res);
        },
        err => console.error(err),
      );
      }


// Subject Type Name Lookup
getJobSubjectType_Q(job_subject_type_id) {
  this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
     data => { 
      let res = data[0]
      this.job_subject_type = data;
      this.subject_job_subject_type = DataUtil.parse.parseJson(res);
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }



  copyToClipboardInGrid(id) {
    // const content = document.getElementById('note_content_' + id).innerHTML; // copy all formatting.
    const content = document.getElementById('paragraph_content_' + id).innerText; // wet to copy text and formatting only
    // const content = document.getElementById('note_content_' + id).textContent; // removes all tags and formatting
    
    this.clipboard.copy(content);
    this,this.toastr.info("Note Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardInGridHTML(id) {
    const content = document.getElementById('paragraph_content_' + id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info("Note Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboard(id) {
    const content = document.getElementById(id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardPlainText(id) {
    const content = document.getElementById(id).innerText; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    // this.clipboard.copy(this.removeTags(content));
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  


  onChangePromtSave(any) {
    //  alert('you have made changes, please remember to save!');
    //  console.log('form changed');
     this.changes_made = null;
    }
  
    onChangePromtSaveHide() {
      //  alert('you have made changes, please remember to save!');
      //  console.log('form changed');
       this.changes_made = 1;
      }


pushBaseModel(base_model){
 if(!this.allAttempts){this.allAttempts = [];}; // detect if array exists.

   // Need to add a filter if already exists
   // @:: https://stackoverflow.com/questions/1988349/array-push-if-does-not-exist
// Find the index of an object with a specific property value
let index = this.allAttempts.findIndex((item) => item.subject_id === base_model.subject_id);


// Check if the object with the specified property value exists in the array
if (index === -1) {
  // If not found, push a new object with the desired properties
  // arrayObj.push({ name: "bar", text: "sour" });
  this.allAttempts.push({
    ...base_model
    })

} else {
  // If found, log a message indicating that the object already exists
 // this.toastr.warning( base_model.subject_id + " Already Exists")
  console.log("Object already exists");

      // do delete and re add
      this.allAttempts.splice(index, 1); // Clears the object and resets the array
      this.allAttempts.push({
        ...base_model
        })

 // this.toastr.info( base_model.subject_id + " Reset and Updated Data")

   
}



      // if(!this.allAttempts){this.allAttempts = [];}; // detect if array exists.
      // // console.log('We have a single object of data selected');
      // if(base_model.subject_id != this.subject_id){ }
      //   this.allAttempts.push({
      //   ...base_model
      //   });
 
// this.toastr.info( this.allAttempts.length + ' Clicked added to search allAttempts'); 


}


      importStarterContentToHTML(id, content_sent, model) {
        // if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
        // model.id = id+'_HTML'
        // const content = document.getElementById(id).innerText; // copy all formatting.
        // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
        // this.clipboard.copy(this.removeTags(content));
        // this.clipboard.copy(content);
  
        const content = content_sent; // copy all formatting.
        // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
         
  
        // this.attemptForm.controls['general_notes_HTML'].setValue(content);
        // this.attemptForm.controls['person_spoken_with_advised_HTML_example'].setValue(content);
        this.model.person_spoken_with_advised_HTML = content;
        // this.attemptForm.controls[id].setValue(content); // encoding must be off for this to work.
        
      //  documentEditor.editor.insertText('Syncfusion');
        

          // this.defaultRTE_spoken.focusIn(); // these two lines work for RichTextEditor
          // // InsertHtml.Insert(document, document.createTextNode(fileurl));
          // InsertHtml.Insert(document, document.createTextNode(content)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // this.defaultRTE_spoken.editor.insertText(content)


        // this.model.person_spoken_with_advised_HTML = content;
        // this.attemptForm.controls[id+'_HTML'].setValue(content);
  
  
        this,this.toastr.info("Sample Entered: " + id)
        // this,this.toastr.info("Sample Entered: " + id+'_HTML')
 // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
        // this.copyInGrid('btnTwo', id);
        // }
      }







      listAction_addMultipleSubjectAttempts(){
        if (confirm('Are you sure you want enter this attempt on multiple subjects?')) {
          // this.isShowSpinnerAgentsInvoicesPaymentsSync = 1;
          // let loop_count = 25;
          // let loop_count = this.search_results.length;
      
            // less than so that it does not automatically loop 20x with no content.
              // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
              // loop_count = this.search_results.length
              // }
      
              // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
              // loop_count = this.gfunc.set_max_sync_number
              // }
      
          
          
             
      let search_results = [];
      search_results = this.allAttempts; // set as a constant.
      
      
          let loop_count = search_results.length;
          this.toastr.success('Length: ' + loop_count);
      
          (async () => {
            // this.isShowSpinnerAgentsInvoicesPaymentsSync = 1;
            for (let i = 0; i < loop_count; i++) { // 
      
      let a = i;


        //  delay(10000) // each retry will start after 5+ second,
        //  console.log('Insert Muliptle Delay...... 10000') // this allows for all automations to run tested up to 10


        // meed tp add resooltions that have been set globally to all attemps subject_service_resolition_outcome_id --
                // auto rate resolution of a service
                                  if(search_results[i].subject_attempt_type_id == 1){
                                    search_results[i].subject_service_resolution_outcome_id = 1;
                                  }
                                  
                                  if(search_results[i].subject_attempt_type_id == 2 && this.gfunc.sessionUserLevel >= 4){
                                    search_results[i].subject_service_resolution_outcome_id = 0;
                                  }

                              search_results[i].job_id = this.job_id;
                              search_results[i].created_by = this.sessionUserId;
                              search_results[i].service_file_array =  JSON.stringify(search_results[i].service_file_array);
                              search_results[i].is_count = this.is_count;  ///??????? do I need to change this to fix counts

                              // stringify the image attachment arrays
                                      search_results[i].property_images =  JSON.stringify(search_results[i].property_images);
                                      search_results[i].property_sign_images =  JSON.stringify(search_results[i].property_sign_images);
                                      search_results[i].property_mail_images =  JSON.stringify(search_results[i].property_mail_images);
                                      search_results[i].property_vehicles_images =  JSON.stringify(search_results[i].property_vehicles_images);
                                      search_results[i].property_pets_images =  JSON.stringify(search_results[i].property_pets_images);
                                      search_results[i].property_occupancy_images =  JSON.stringify(search_results[i].property_occupancy_images);
                                      search_results[i].property_condition_images =  JSON.stringify(search_results[i].property_condition_images);
                                      search_results[i].property_type_images =  JSON.stringify(search_results[i].property_type_images);

                        // Set the default HTML fields before going live - HTML -- Remove this when going to new format Nov 2023
                        // x17 fields
                        if(search_results[i].general_notes_HTML == null){

                        }


                        // look up names here to add into notes july 2022 updates
                              this.getServiceMethod(search_results[i].subject_service_method_id);
                              this.getSubjectAttemptType(search_results[i].subject_attempt_type_id);
                              // email set
                              search_results[i].email_address_served = this.email_address_served; // sets from drop down

                              
                              // August 2023 - TimeZone Fixed Text
                                // set a fixed time
                                const dateTime = new Date(search_results[i].time_service).toLocaleTimeString('en-AU', {
                                  hour: 'numeric', minute: 'numeric', hour12: true
                                  });


                                // this.search_results[i].time_service_text = this.mytime;
                                          // this.search_results[i].time_service_text = dateTime;
                                          // search_results[i].time_service_text = dateTime;

                                          // // Plain text Paragrap. strip the tags through a function // SEE IF THIS WORDS TO CREATE  NON formatted paragraph automatically
                                          // search_results[i].service_paragraph_rendered_plain_text = this.removeTags(search_results[i].service_paragraph_rendered);


    //  this.createSubjectService(search_results[i]) // reqrite this function so that I can loop and get a response back.
//  let body = JSON.stringify(model);
// return this.http.post( this.$api_get_url + '/api/job/subject/service/create/' + model.subject_id, body, httpOptions);


          
          //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.
      

      
                      // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                      // let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                      // this.http.post(this.gfunc.sopNodeURL + '/postNewWorkOrderPayments/fromTSA', body, httpOptions)
                      let body = JSON.stringify(search_results[i]);
                      this.http.post( this._demoService.$api_get_url + '/api/job/subject/service/create/' + search_results[i].subject_id, body, httpOptions)
                      .pipe(
                      this.toastr.observe({
                        loading: 'Checking... Action: Gathering All Attempts & Subject Datas ...',
                        success: '🚀...',
                        error: '...😡...'
                      })
                      )
                      .pipe(
                      retry(0), // you retry 3 times
                      // delay(1500) // each retry will start after 1 second,
                      
                      // delay(6000) // each retry will start after 4 seconds, -- dont need here
                      ).subscribe(
                      data => { this.get_latest_subject_service_id = data;
      
                      let res = data[0];
                      // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                      // this.response_from_node = JSON.stringify(data);
   
      
                          // end resoponse.
                          console.log('Count: ' + i)
                      if(i == (loop_count - 1)){
          
                        // this.isShowSpinnerAgentsInvoicesPaymentsSync = 0;
                        this.toastr.success("We have processed the full action list.")
                        // Go to original Subject Page.
                         this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
      
                        //  Commented out for testing multiples may 2025
                     this.closeParentModel.emit();



                      //  this.clearSearchResults(); // I now clear the array
                      }
                            // refreshnumbers\
      
                            // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                            // // smaller delay if count is less then the maximum -- NEW.
                            // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                            //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                            // }else{
                            // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                            //   }
                            // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                            // setTimeout(() => {  
                            //   this.getPendingClientsInvoicesPayments();
                            //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                            //   this.StartRunIntervalFuntions()
                            // }, set_delay )
      
                //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                            // this.getPendingAgentsInvoicesPayments();



      // Also need to change Subject Status. -- changed the order.... 
                                          // if agent and service // SERVED 
                                          if(this.gfunc.sessionUserLevel == 5 && search_results[i].subject_attempt_type_id == 1){
                                            // this.updateSubjectStatus(model, "SERVED");
                                            this.updateSubjectStatus(search_results[i], "SERVD");
                                          }
                                          //Attendance
                                          if(this.gfunc.sessionUserLevel == 5 && search_results[i].subject_attempt_type_id == 2){
                                            // this.updateSubjectStatus(model, "UPDRECEIVED");
                                            this.updateSubjectStatus(search_results[i], "UPDREC");
                                          }



                                          // :: @ INSERT NOTE & LOG this inserts both on create.
                                          // this.createSubjectNote(search_results[i]);
                                          this.createSubjectNoteMultipleNew(search_results[i]);

                                    

                                          // if agent and attemt //UPDRECEIVED
                                          
                                          
                                          // :: @ SCRIPT SKIPS ROUT IN FUNCTION ABOVE>

                                        
                                          if (search_results[i].send_communications == true) {
                                     //   this.sendAttemptCommunications(search_results[i]);
                                          }

                                            /// Did not worke.
                                            // refresh the imported subject component
                                            // SubjectEditComponent.returned.next(false);

                                              //  return true;
                                          this.toastr.success("Subject Attempt Added");

   
                                          this.toastr.info('Attempt Complete: = ' + search_results[i].subject_number + ' ResponseID: ' + res )
                                          console.log('Attempt Complete: = ' + search_results[i].subject_number + ' ResponseID: ' + res )
      
      
             
                                          // Experiment to get the index and change
                                        // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                                        // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                                        // :: Simple and cool way to update the model.
                                        let  objIndex =  this.allAttempts.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                                        this.allAttempts[objIndex].RowVersion = "DONE";


                             





          
      
                      },
                      err => {
                      this.toastr.success('We encounted issues please refer to below,...', err.error);
                              // refreshnumbers\
                              // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                              // this.StartRunIntervalFuntions()
                              let  objIndex =   this.allAttempts.findIndex(obj => obj.subject_number == this.search_results[i].subject_number);
                              this.allAttempts[objIndex].RowVersion = "ERROR";
                      
                      console.error(err);
                                // this.response_from_node = JSON.stringify(err);
                                // this.response_from_node_raw = err;
                
                                // // Need to set some error varibles
                                // this.error_message = err.error.error_message;
                                // this.error_message_standard = err.error.error_message_standard;
                                // this.error_name = err.error.error_name;
                                // this.full_response_data = err.error.full_response_data;
                                // this.data_sent = err.error.data_sent;
                                // this.data_sent_id = err.error.payment_id;
                                // this.data_sent_DisplayID = err.error.data_sent.customer_UID;
                
                                // //Set these up for payments
                                // this.data_sent_client_brand_id = err.error.customer_UID;
                                // this.data_sent_agent_brand_id = null;
                                // this.data_sent_invoice_id = err.error.invoice_UID;
                                // this.data_sent_invoice_UID = err.error.invoice_UID;
                                // this.data_sent_client_invoice_id = err.error.invoice_id;
                                // this.data_sent_agent_invoice_id = null;
                                // // if(this.data_sent_invoice_UID != null){
                                // // this.getSubjectInvoiceByInvoiceByUID(this.data_sent_invoice_UID) // gets the invoice the payment was applied to.
                
                                // // }
                                // this.data_sent_invoice_payment_id = err.error.payment_id;
                                // this.data_sent_work_order_payment_id = null;
                
                
                                // this.full_response_status = err.error.full_response_staus;
                                // this.full_response_headers = err.error.full_response_headers;
                                // this.full_response = err.error.full_response;
      
                    
      
                      }
                      
                    );
      
      
      
      
            // console.log ("Block statement execution no." + this.search_results[i].subject_number);       
                // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
                // this.toastr.success('Processing with await 12000');
                this.toastr.success('Processing');
                // this.toastr.info("Inside")
      
      
         await this.delay(800); // works perfect. (11000)
        //  await this.delay(12000); // works perfect. (11000)
                // await this.delay(15000); // works perfect. (11000)
                      // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
                   
             
      
      
         
             }
            //  this.getPendingClientsInvoicesPayments();
         
          })(); // end async function
            
      
      
                // this.getPendingClientsInvoicesPayments();
        
                // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
             
                this.toastr.success("We have processed the full action list.")
        // this.getPendingAgentsInvoicesPayments()
      
      }
      
    
    }


// delay function
delay(ms: number) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}



onTimeChange_NoZone(model) {
this.model.time_service = this.setTimeServiceFromText(model.date_service, model.time_service_24hr);


        // This changes the time of the service_text
  if (model.time_service instanceof Date) {
    const hours = model.time_service.getHours().toString().padStart(2, '0');
    const minutes = model.time_service.getMinutes().toString().padStart(2, '0');


    // Optional: If you want 12h format with AM/PM
    const ampm = +hours >= 12 ? 'PM' : 'AM';
    const hour12 = ((+hours % 12) || 12).toString();

    // Save a pure 24h time string
    // model.time_service_text = `${hours}:${minutes}`;
    model.time_service_text = `${hour12}:${minutes} ${ampm}`; // so that we get am and pm?


    model.time_service_text_12hr = `${hour12}:${minutes} ${ampm}`;
  }

}



// I need a function to set the service time based on the selection, and that way I can make the system backwards compatable with the dates
setTimeServiceFromText(dateStr: string | Date, timeStr: any): Date {
 
  // if (!dateStr || !timeStr) return null;

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return null;

  // Extract parts from time string (e.g., "3:45 PM")
  const timeParts = timeStr.trim().match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
  if (!timeParts) return null;

  let [_, hourStr, minuteStr, ampm] = timeParts;
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  if (ampm) {
    ampm = ampm.toUpperCase();
    if (ampm === 'PM' && hour < 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;
  }

  // Clone date and set time
  const combined = new Date(date);
  combined.setHours(hour, minute, 0, 0); // zero seconds/milliseconds

  return combined;
}



toggleSection(id: string) {
  this.sections[id] = !this.sections[id];
}

getButtonLabel(id: string, label: string): string {
  return this.sections[id]
    ? `Hide ${label}`
    : `Show ${label}`;
}

isSectionSkipped(id: string): boolean {
  return this.sections[id] === false;
}

toggleSectionWithConfirm(id: string, label: string) {
  if (!this.confirmOptionalFieldsToggle(!!this.sections[id], label)) {
    return;
  }

  this.toggleSection(id);

  if (!this.sections[id]) {
    this.form_validator_switch_value = false;
  }
}


// New group and validation show hide based on skip / 2026 April

// Toggle ONE group
toggleGroup(group: string) {
  this.sectionGroups[group] = !(this.sectionGroups[group] !== false);
}

toggleGroupWithConfirm(group: string, label: string) {
  if (!this.confirmOptionalFieldsToggle(this.isGroupOpen(group), label)) {
    return;
  }

  this.toggleGroup(group);

  if (!this.isGroupOpen(group)) {
    this.form_validator_switch_value = false;
  }
}

// Toggle MULTIPLE groups
toggleGroups(groups: string[]) {
  const shouldOpen = groups.some(g => this.sectionGroups[g] === false);

  groups.forEach(g => {
    this.sectionGroups[g] = shouldOpen;
  });
}

// Is open
isGroupOpen(group: string): boolean {
  return this.sectionGroups[group] !== false;
}

isGroupSkipped(group: string): boolean {
  return this.sectionGroups[group] === false;
}

isGeneralNotesRequired(): boolean {
  return this.model?.subject_service_outcome_id >= 8
    && (
      this.isSectionSkipped('section29')
      || this.isGroupSkipped(this.GROUPS.OCCUPANCY_11_12)
    );
}

// Any open
isAnyGroupOpen(groups: string[]): boolean {
  return groups.some(g => this.sectionGroups[g] !== false);
}

// Skip validation for one group
skipGroupValidation(group: string) {
  this.skipValidationGroups[group] = true;
  this.sectionGroups[group] = false;
}

// Turn validation back on for one group
enableGroupValidation(group: string) {
  this.skipValidationGroups[group] = false;
}

// Use validation?
useGroupValidation(group: string): boolean {
  return this.skipValidationGroups[group] !== true;
}

// Button label
getGroupLabel(group: string, label: string): string {
  return this.isGroupOpen(group) ? `Hide ${label}` : `Show ${label}`;
}

// Optional helper for one-click skip + hide
skipAndToggleGroup(group: string) {
  this.skipGroupValidation(group);
}



}
     
